function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var deepmerge = _interopDefault(require('deepmerge'));

var equal = _interopDefault(require('react-fast-compare'));

var fileSaver = require('file-saver');

var produce = _interopDefault(require('immer'));

var utils = require('@syndesis/utils');

var React = require('react');

var ApiContextDefaultValue = {
  apiUri: 'http://example.com',
  dvApiUri: 'http://example.com',
  headers: {}
};
var ApiContext = React.createContext(ApiContextDefaultValue);
var referrerPolicyId = 'referrerPolicy';
var acceptId = 'Accept';
var contentTypeId = 'Content-Type';

function callFetch(ref) {
  var url = ref.url;
  var method = ref.method;
  var headers = ref.headers;
  if (headers === void 0) headers = {};
  var body = ref.body;
  var includeContentType = ref.includeContentType;
  if (includeContentType === void 0) includeContentType = true;
  var contentType = ref.contentType;
  if (contentType === void 0) contentType = 'application/json; charset=utf-8';
  var includeAccept = ref.includeAccept;
  if (includeAccept === void 0) includeAccept = true;
  var accept = ref.accept;
  if (accept === void 0) accept = 'application/json,text/plain,*/*';
  var includeReferrerPolicy = ref.includeReferrerPolicy;
  if (includeReferrerPolicy === void 0) includeReferrerPolicy = true;
  var stringifyBody = ref.stringifyBody;
  if (stringifyBody === void 0) stringifyBody = true;
  headers = Object.assign({}, headers);

  if (includeAccept && !(acceptId in headers)) {
    headers[acceptId] = accept;
  }

  if (includeContentType && !(contentTypeId in headers)) {
    headers[contentTypeId] = contentType;
  }

  if (includeReferrerPolicy && !(referrerPolicyId in headers)) {
    headers[referrerPolicyId] = 'no-referrer';
  }

  var data = headers[contentTypeId] && headers[contentTypeId].includes('application/json') && stringifyBody ? JSON.stringify(body) : body;
  return fetch(url, {
    body: data,
    cache: 'no-cache',
    credentials: 'include',
    headers: Object.assign({}, headers),
    method: method,
    mode: 'cors',
    redirect: 'follow'
  });
}

(function (MessageLevel) {
  MessageLevel["INFO"] = "INFO";
  MessageLevel["WARN"] = "WARN";
  MessageLevel["ERROR"] = "ERROR";
})(exports.MessageLevel || (exports.MessageLevel = {}));

var NEW_INTEGRATION_ID = 'new-integration';
var NEW_INTEGRATION = {
  id: NEW_INTEGRATION_ID,
  name: '',
  tags: []
}; // Data shape kind enum when working with the DataShape type

(function (DataShapeKinds) {
  DataShapeKinds["ANY"] = "any";
  DataShapeKinds["JAVA"] = "java";
  DataShapeKinds["JSON_SCHEMA"] = "json-schema";
  DataShapeKinds["JSON_INSTANCE"] = "json-instance";
  DataShapeKinds["XML_SCHEMA"] = "xml-schema";
  DataShapeKinds["XML_SCHEMA_INSPECTED"] = "xml-schema-inspected";
  DataShapeKinds["XML_INSTANCE"] = "xml-instance";
  DataShapeKinds["NONE"] = "none";
})(exports.DataShapeKinds || (exports.DataShapeKinds = {})); // These are message codes that we know about


(function (MessageCode) {
  MessageCode["SYNDESIS000"] = "SYNDESIS000";
  MessageCode["SYNDESIS001"] = "SYNDESIS001";
  MessageCode["SYNDESIS002"] = "SYNDESIS002";
  MessageCode["SYNDESIS003"] = "SYNDESIS003";
  MessageCode["SYNDESIS004"] = "SYNDESIS004";
  MessageCode["SYNDESIS005"] = "SYNDESIS005";
  MessageCode["SYNDESIS006"] = "SYNDESIS006";
  MessageCode["SYNDESIS007"] = "SYNDESIS007";
  MessageCode["SYNDESIS008"] = "SYNDESIS008";
})(exports.MessageCode || (exports.MessageCode = {})); // Integration status types and consts


var PENDING = 'Pending';
var PUBLISHED = 'Published';
var UNPUBLISHED = 'Unpublished';
var ERROR = 'Error';

(function (IntegrationType) {
  IntegrationType["SingleFlow"] = "SingleFlow";
  IntegrationType["ApiProvider"] = "ApiProvider";
  IntegrationType["MultiFlow"] = "MultiFlow";
})(exports.IntegrationType || (exports.IntegrationType = {})); // These types are for the integration detailed state


(function (ConsoleLinkType) {
  ConsoleLinkType["Events"] = "EVENTS";
  ConsoleLinkType["Logs"] = "LOGS";
})(exports.ConsoleLinkType || (exports.ConsoleLinkType = {}));

(function (DetailedStatus) {
  DetailedStatus["Assembling"] = "ASSEMBLING";
  DetailedStatus["Building"] = "BUILDING";
  DetailedStatus["Deploying"] = "DEPLOYING";
  DetailedStatus["Starting"] = "STARTING";
})(exports.DetailedStatus || (exports.DetailedStatus = {}));

(function (FlowType) {
  FlowType["PRIMARY"] = "PRIMARY";
  FlowType["API_PROVIDER"] = "API_PROVIDER";
  FlowType["ALTERNATE"] = "ALTERNATE";
})(exports.FlowType || (exports.FlowType = {}));

(function (FlowKind) {
  FlowKind["CONDITIONAL"] = "conditional";
  FlowKind["DEFAULT"] = "default";
})(exports.FlowKind || (exports.FlowKind = {}));

var FLOW_KIND_METADATA_KEY = 'kind';
var EXCERPT_METADATA_KEY = 'excerpt';
var STEP_ID_METADATA_KEY = 'stepId';
var PRIMARY_FLOW_ID_METADATA_KEY = 'primaryFlowId'; // Special sekret connection metadata keys

var HIDE_FROM_STEP_SELECT = 'hide-from-step-select';
var HIDE_FROM_CONNECTION_PAGES = 'hide-from-connection-pages'; // stuff used by the ui to compute the StepKinds

var EXTENSION = 'extension';
var ENDPOINT = 'endpoint';
var FLOW = 'flow';
var CONNECTION = ENDPOINT;
var DATA_MAPPER = 'mapper';
var BASIC_FILTER = 'ruleFilter';
var ADVANCED_FILTER = 'expressionFilter';
var SPLIT = 'split';
var AGGREGATE = 'aggregate';
var LOG = 'log';
var TEMPLATE = 'template';
var API_PROVIDER = 'api-provider';
var CONNECTOR = 'connector';
var CHOICE = 'choice'; // A type of promise-like that resolves synchronously and supports only one observer

var _Pact = function () {
  function _Pact() {}

  _Pact.prototype.then = function (onFulfilled, onRejected) {
    var result = new _Pact();
    var state = this.s;

    if (state) {
      var callback = state & 1 ? onFulfilled : onRejected;

      if (callback) {
        try {
          _settle(result, 1, callback(this.v));
        } catch (e) {
          _settle(result, 2, e);
        }

        return result;
      } else {
        return this;
      }
    }

    this.o = function (_this) {
      try {
        var value = _this.v;

        if (_this.s & 1) {
          _settle(result, 1, onFulfilled ? onFulfilled(value) : value);
        } else if (onRejected) {
          _settle(result, 1, onRejected(value));
        } else {
          _settle(result, 2, value);
        }
      } catch (e) {
        _settle(result, 2, e);
      }
    };

    return result;
  };

  return _Pact;
}(); // Settles a pact synchronously


function _settle(pact, state, value) {
  if (!pact.s) {
    if (value instanceof _Pact) {
      if (value.s) {
        if (state & 1) {
          state = value.s;
        }

        value = value.v;
      } else {
        value.o = _settle.bind(null, pact, state);
        return;
      }
    }

    if (value && value.then) {
      value.then(_settle.bind(null, pact, state), _settle.bind(null, pact, 2));
      return;
    }

    pact.s = state;
    pact.v = value;
    var observer = pact.o;

    if (observer) {
      observer(pact);
    }
  }
}

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
} // Asynchronously await a promise and pass the result to a finally continuation


function _finallyRethrows(body, finalizer) {
  try {
    var result = body();
  } catch (e) {
    return finalizer(true, e);
  }

  if (result && result.then) {
    return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
  }

  return finalizer(false, value);
} // Asynchronously await a promise and invoke a finally continuation that always overrides the result


var _earlyReturn = {}; // Asynchronously call a function and send errors to recovery continuation, skipping early returns

var _AsyncGenerator = function () {
  function _AsyncGenerator(entry) {
    this._entry = entry;
    this._pact = null;
    this._resolve = null;
    this._return = null;
    this._promise = null;
  }

  function _wrapReturnedValue(value) {
    return {
      value: value,
      done: true
    };
  }

  function _wrapYieldedValue(value) {
    return {
      value: value,
      done: false
    };
  }

  _AsyncGenerator.prototype[Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))] = function () {
    return this;
  };

  _AsyncGenerator.prototype._yield = function (value) {
    // Yield the value to the pending next call
    this._resolve(value && value.then ? value.then(_wrapYieldedValue) : _wrapYieldedValue(value)); // Return a pact for an upcoming next/return/throw call


    return this._pact = new _Pact();
  };

  _AsyncGenerator.prototype.next = function (value) {
    // Advance the generator, starting it if it has yet to be started
    var _this = this;

    return _this._promise = new Promise(function (resolve) {
      var _pact = _this._pact;

      if (_pact === null) {
        var returnValue = function returnValue(value) {
          _this._resolve(value && value.then ? value.then(_wrapReturnedValue) : _wrapReturnedValue(value));

          _this._pact = null;
          _this._resolve = null;
        };

        var _entry = _this._entry;

        if (_entry === null) {
          // Generator is started, but not awaiting a yield expression
          // Abandon the next call!
          return resolve(_this._promise);
        } // Start the generator


        _this._entry = null;
        _this._resolve = resolve;

        _entry(_this).then(returnValue, function (error) {
          if (error === _earlyReturn) {
            returnValue(_this._return);
          } else {
            var pact = new _Pact();

            _this._resolve(pact);

            _this._pact = null;
            _this._resolve = null;

            _resolve(pact, 2, error);
          }
        });
      } else {
        // Generator is started and a yield expression is pending, settle it
        _this._pact = null;
        _this._resolve = resolve;

        _settle(_pact, 1, value);
      }
    });
  };

  _AsyncGenerator.prototype.return = function (value) {
    // Early return from the generator if started, otherwise abandons the generator
    var _this = this;

    return _this._promise = new Promise(function (resolve) {
      var _pact = _this._pact;

      if (_pact === null) {
        if (_this._entry === null) {
          // Generator is started, but not awaiting a yield expression
          // Abandon the return call!
          return resolve(_this._promise);
        } // Generator is not started, abandon it and return the specified value


        _this._entry = null;
        return resolve(value && value.then ? value.then(_wrapReturnedValue) : _wrapReturnedValue(value));
      } // Settle the yield expression with a rejected "early return" value


      _this._return = value;
      _this._resolve = resolve;
      _this._pact = null;

      _settle(_pact, 2, _earlyReturn);
    });
  };

  _AsyncGenerator.prototype.throw = function (error) {
    // Inject an exception into the pending yield expression
    var _this = this;

    return _this._promise = new Promise(function (resolve, reject) {
      var _pact = _this._pact;

      if (_pact === null) {
        if (_this._entry === null) {
          // Generator is started, but not awaiting a yield expression
          // Abandon the throw call!
          return resolve(_this._promise);
        } // Generator is not started, abandon it and return a rejected Promise containing the error


        _this._entry = null;
        return reject(error);
      } // Settle the yield expression with the value as a rejection


      _this._resolve = resolve;
      _this._pact = null;

      _settle(_pact, 2, error);
    });
  };

  return _AsyncGenerator;
}();

var Fetch =
/*@__PURE__*/
function (superclass) {
  function Fetch(props) {
    superclass.call(this, props);
    this.read = this.read.bind(this);
    this.state = {
      data: this.props.initialValue || this.props.defaultValue,
      error: false,
      hasData: !!this.props.initialValue,
      loading: true
    };
  }

  if (superclass) Fetch.__proto__ = superclass;
  Fetch.prototype = Object.create(superclass && superclass.prototype);
  Fetch.prototype.constructor = Fetch;

  Fetch.prototype.componentDidMount = function componentDidMount() {
    try {
      var _this = this;

      _this.read();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  Fetch.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    try {
      var _this2 = this;

      if (prevProps.url !== _this2.props.url) {
        _this2.read();
      }
    } catch (e) {
      return Promise.reject(e);
    }
  };

  Fetch.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    return !equal(this.props, nextProps) || !equal(this.state, nextState);
  };

  Fetch.prototype.render = function render() {
    return this.props.children({
      read: this.read,
      response: this.state
    });
  };

  Fetch.prototype.read = function read() {
    try {
      var _this3 = this;

      return _catch(function () {
        _this3.setState({
          error: false,
          errorMessage: undefined,
          loading: true
        });

        return Promise.resolve(callFetch({
          body: _this3.props.body,
          contentType: _this3.props.contentType,
          headers: _this3.props.headers,
          method: _this3.props.method || 'GET',
          url: "" + _this3.props.baseUrl + _this3.props.url
        })).then(function (response) {
          function _temp2() {
            _this3.setState({
              data: data,
              hasData: true,
              loading: false
            });
          }

          if (!response.ok) {
            throw new Error(response.statusText);
          }

          var data;

          var _temp = function () {
            if (!_this3.props.contentType || _this3.props.contentType.indexOf('application/json') === 0) {
              return Promise.resolve(response.json()).then(function (_response$json) {
                data = _response$json;

                if (_this3.props.defaultValue) {
                  data = deepmerge(_this3.props.defaultValue, data);
                }
              });
            } else {
              return Promise.resolve(response.text()).then(function (_response$text) {
                data = _response$text;
              });
            }
          }();

          return _temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp);
        });
      }, function (e) {
        _this3.setState({
          data: _this3.props.defaultValue,
          error: true,
          errorMessage: e.message,
          hasData: false,
          loading: false
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return Fetch;
}(React.Component);

function objectWithoutProperties(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

var DVFetch =
/*@__PURE__*/
function (superclass) {
  function DVFetch() {
    superclass.apply(this, arguments);
  }

  if (superclass) DVFetch.__proto__ = superclass;
  DVFetch.prototype = Object.create(superclass && superclass.prototype);
  DVFetch.prototype.constructor = DVFetch;

  DVFetch.prototype.render = function render() {
    var ref = this.props;
    var url = ref.url;
    var rest = objectWithoutProperties(ref, ["url", "stream"]);
    var props = rest;
    return React.createElement(ApiContext.Consumer, null, function (ref) {
      var dvApiUri = ref.dvApiUri;
      return React.createElement(Fetch, Object.assign({
        baseUrl: dvApiUri,
        url: url,
        headers: {}
      }, props));
    });
  };

  return DVFetch;
}(React.Component);

function getActionsWithFrom(actions) {
  if (actions === void 0) actions = [];
  return actions.filter(function (a) {
    return a.pattern === 'From';
  });
}

function getActionsWithTo(actions) {
  if (actions === void 0) actions = [];
  return actions.filter(function (a) {
    return a.pattern === 'To';
  });
}

function getConnectionMetadataValue(connection, key) {
  var metadata = connection.metadata || {};
  return metadata[key];
}

function getConnectionConnector(connection) {
  if (!connection.connector) {
    throw Error("FATAL: Connection " + connection.id + " doesn't have a connector");
  }

  return connection.connector;
}

function getConnectorActions(connector) {
  return connector.actions;
}

function getActionById(actions, actionId) {
  var action = actions.find(function (a) {
    return a.id === actionId;
  });

  if (!action) {
    throw Error("FATAL: Action " + actionId + " not found");
  }

  return action;
}

function getActionDescriptor(action) {
  if (!action.descriptor) {
    throw Error("FATAL: Action " + action.id + " doesn't have any descriptor");
  }

  return action.descriptor;
}

function getActionSteps(descriptor) {
  if (!descriptor.propertyDefinitionSteps) {
    throw Error("FATAL: Descriptor doesn't have any definition");
  }

  return descriptor.propertyDefinitionSteps;
}

function getActionStep(steps, step) {
  if (step > steps.length - 1) {
    throw Error("FATAL: Step " + step + " does not exist in the descriptor steps");
  }

  return steps[step];
}

function getActionStepDefinition(step) {
  if (!step.properties) {
    throw Error("FATAL: Step " + step + " does not have valid properties");
  }

  return step.properties;
}
/**
 * Return bool if a connection is derived, meaning that its configuration comes
 * from an OAuth flow. This helper is to work around a bug in the swagger definition
 * that names the property we can use to know this as `derived`, but it's really
 * returned to us as `isDerived`.
 *
 * To make the helper future proof, this uses both properties to save us from
 * a sudden fix in the API.
 * @param connection
 */


function isDerived(connection) {
  return connection.isDerived || connection.derived;
}
/**
 * Returns a new integration object, adding or replacing the supplied flow
 * @param integration
 * @param flow
 * @param getSanitizedSteps
 */


var setFlow = function setFlow(integration, flow, getSanitizedSteps) {
  try {
    return Promise.resolve(sanitizeFlow(flow, getSanitizedSteps)).then(function (_sanitizeFlow) {
      flow = _sanitizeFlow;

      if (getFlow(integration, flow.id)) {
        return Object.assign({}, integration, {
          flows: integration.flows.map(function (f) {
            if (f.id === flow.id) {
              return flow;
            }

            return f;
          })
        });
      } else {
        return Object.assign({}, integration, {
          flows: integration.flows.concat([flow])
        });
      }
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
/**
 * Returns a new integration object containing the supplied conditional flows for the given step ID
 * @param integration
 * @param newFlows
 * @param configuredFlowIds
 * @param defaultFlowId
 * @param stepId
 */


var sanitizeFlow = function sanitizeFlow(flow, getSanitizedSteps) {
  try {
    return Promise.resolve(getSanitizedSteps(flow.steps || [])).then(function (_getSanitizedSteps) {
      flow.steps = _getSanitizedSteps; // make sure we have all the connection ids as tags for the flow

      flow.tags = Array.from(new Set((flow.tags || []).concat(flow.steps.filter(function (s) {
        return s.connection && s.connection.id;
      }).map(function (s) {
        return s.connection.id;
      })))); // Ensure the type is set properly on the flow, if it's not set we assume it's a primary flow

      flow.type = flow.type || exports.FlowType.PRIMARY; // for the api provider, if a flow has been modified we change the last
      // step of the flow to automatically set a return code of 200, unless
      // already modified by the user. Also, we update the flow metadata to
      // reflect that the flow has been "implemented"

      var lastStep = flow.steps[flow.steps.length - 1];

      if (lastStep && lastStep.action && lastStep.action.id === 'io.syndesis:api-provider-end') {
        if (!lastStep.configuredProperties || lastStep.configuredProperties && lastStep.configuredProperties.httpResponseCode === '501') {
          var returnCode = flow.metadata['default-return-code'];
          var returnCodeEdited = flow.metadata['return-code-edited'];

          if (returnCode && !returnCodeEdited) {
            flow.metadata['return-code-edited'] = 'true';
            lastStep.configuredProperties.httpResponseCode = returnCode;
          }
        }
      }

      return flow;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

function toDataShapeKindType(kind) {
  return kind.toLowerCase();
}

function toDataShapeKinds(kind) {
  switch (kind.toLowerCase()) {
    case 'any':
      return exports.DataShapeKinds.ANY;

    case 'java':
      return exports.DataShapeKinds.JAVA;

    case 'json_schema':
    case 'json-schema':
      return exports.DataShapeKinds.JSON_SCHEMA;

    case 'json_instance':
    case 'json-instance':
      return exports.DataShapeKinds.JSON_INSTANCE;

    case 'xml_schema':
    case 'xml-schema':
      return exports.DataShapeKinds.XML_SCHEMA;

    case 'xml_schema_inspected':
    case 'xml-schema-inspected':
      return exports.DataShapeKinds.XML_SCHEMA_INSPECTED;

    case 'xml_instance':
    case 'xml-instance':
      return exports.DataShapeKinds.XML_INSTANCE;

    case 'none':
      return exports.DataShapeKinds.NONE;

    default:
      throw new Error("Invalid data shape kind: " + kind);
  }
}
/**
 * returns an empty integration object.
 *
 */


function getEmptyIntegration() {
  return produce(NEW_INTEGRATION, function (draft) {
    draft.flows = [{
      id: utils.key(),
      name: '',
      steps: []
    }];
  });
}

function setIntegrationProperties(integration, properties) {
  return produce(integration, function (nextIntegration) {
    Object.keys(properties).forEach(function (k) {
      nextIntegration[k] = properties[k];
    });
  });
}
/**
 * returns true if the provided integration can be published; returns false
 * otherwise.
 *
 * @param integration
 */


function canPublish(integration) {
  return integration.currentState !== 'Pending';
}
/**
 * returns true if the provided integration can be activated; returns false
 * otherwise.
 *
 * @param integration
 */


function canActivate(integration) {
  return integration.currentState !== 'Pending' && integration.currentState !== 'Published';
}
/**
 * returns true if the provided integration can be edited; returns false
 * otherwise.
 *
 * @param integration
 */


function canEdit(integration) {
  return integration.currentState !== 'Pending';
}
/**
 * returns true if the provided integration can be deactivated; returns false
 * otherwise.
 *
 * @param integration
 */


function canDeactivate(integration) {
  return integration.currentState !== 'Unpublished';
}
/**
 * returns the list of steps of the provided integration.
 *
 * @param integration
 * @param flowId
 *
 * @todo make the returned object immutable to avoid uncontrolled changes
 */


function getSteps(integration, flowId) {
  try {
    var flow = getFlow(integration, flowId);
    return flow.steps;
  } catch (e) {
    return [];
  }
} //
// Various helper functions that the current flow service uses to build an integration object
//


function setFlowId(flow) {
  return flow.id ? flow : Object.assign({}, flow, {
    id: utils.key()
  });
}

function setStepId(step) {
  return step.id ? step : Object.assign({}, step, {
    id: utils.key()
  });
}
/**
 * Validate and add/correct items in a flow's step array
 *  * Sets step IDs
 *  * Strips out invalid/unconfigured steps
 * @param flow
 */


function validateFlowSteps(flow) {
  return Object.assign({}, flow, {
    steps: (flow.steps || []).map(setStepId).filter(function (s) {
      return typeof s.stepKind !== 'undefined';
    })
  });
}
/**
 * Validate all flows and add/correct items as needed
 * @param flows
 */


function validateFlows(flows) {
  if (flows === void 0) flows = [];
  return flows.map(setFlowId).map(validateFlowSteps);
}
/**
 * Create or enrich the tags for an integration
 * @param flows
 * @param tags
 */


function buildTags(flows, tags) {
  var ref;
  if (flows === void 0) flows = [];
  if (tags === void 0) tags = [];
  var connectorIds = (ref = []).concat.apply(ref, flows.map(function (f) {
    return f.steps.filter(function (step) {
      return step.stepKind === ENDPOINT && typeof step.connection !== 'undefined';
    }).map(function (step) {
      return step.connection.connectorId;
    });
  }));
  return Array.from(new Set(tags.concat(connectorIds)));
}
/**
 * Creates a map of default configured property values for the given properties object
 * @param properties
 */


function getDefaultsFromProperties(properties) {
  return Object.keys(properties).reduce(function (result, k) {
    var obj;
    return Object.assign({}, result, (obj = {}, obj[k] = properties[k].defaultValue, obj));
  }, {});
}

function getDefaultsForPropertyDefinitionStep(propertyDefinitionStep) {
  return getDefaultsFromProperties(propertyDefinitionStep.properties);
}
/**
 * Extracts out the default configuredProperty values for the supplied propertyDefinitionSteps
 * @param propertyDefinitionSteps
 */


function getPropertyDefaults(propertyDefinitionSteps) {
  if (propertyDefinitionSteps === void 0) propertyDefinitionSteps = [];
  return propertyDefinitionSteps.map(getDefaultsForPropertyDefinitionStep).reduce(function (result, current) {
    return Object.assign({}, result, current);
  }, {});
}
/**
 * Inspects the supplied data shape and determines if the user set it on the step or not
 * @param dataShape
 */


function isUserDefinedDataShape(dataShape) {
  return dataShape && dataShape.metadata && dataShape.metadata.userDefined === 'true';
}
/**
 * Checks if the supplied step has either an input or output data shape
 * @param step
 * @param isInput
 */


function hasDataShape(step, isInput) {
  if (isInput === void 0) isInput = false;

  if (!step.action || !step.action.descriptor) {
    return false;
  }

  var descriptor = step.action.descriptor;
  var dataShape = isInput ? descriptor.inputDataShape : descriptor.outputDataShape;
  return dataShape && dataShape.kind && toDataShapeKinds(dataShape.kind) !== exports.DataShapeKinds.NONE;
}
/**
 * Returns whether or not the supplied descriptor has an input or output datashape of ANY
 * @param descriptor
 */


function isActionShapeless(descriptor) {
  if (!descriptor) {
    return false;
  }

  var inputDataShape = descriptor.inputDataShape;
  var outputDataShape = descriptor.outputDataShape;
  return inputDataShape && outputDataShape && inputDataShape.kind && outputDataShape.kind && (toDataShapeKinds(inputDataShape.kind) === exports.DataShapeKinds.ANY || toDataShapeKinds(outputDataShape.kind) === exports.DataShapeKinds.ANY);
}
/**
 * Returns whether or not the supplied descriptor has an input datashape of ANY
 * @param descriptor
 */


function isActionInputShapeless(descriptor) {
  if (!descriptor) {
    return false;
  }

  var inputDataShape = descriptor.inputDataShape;
  return inputDataShape && inputDataShape.kind && toDataShapeKinds(inputDataShape.kind) === exports.DataShapeKinds.ANY;
}

function requiresOutputDescribeDataShape(descriptor) {
  if (!descriptor) {
    return false;
  }

  if (isActionOutputShapeless(descriptor)) {
    return true;
  }

  return isUserDefinedDataShape(descriptor.outputDataShape);
}

function requiresInputDescribeDataShape(descriptor) {
  if (!descriptor) {
    return false;
  }

  if (isActionInputShapeless(descriptor)) {
    return true;
  }

  return isUserDefinedDataShape(descriptor.inputDataShape);
}
/**
 * Returns whether or not the supplied descriptor has an output datashape of ANY
 * @param descriptor
 */


function isActionOutputShapeless(descriptor) {
  if (!descriptor) {
    return false;
  }

  var outputDataShape = descriptor.outputDataShape;
  return outputDataShape && outputDataShape.kind && toDataShapeKinds(outputDataShape.kind) === exports.DataShapeKinds.ANY;
}
/**
 * Sets an arbitrary property on an integration
 * @param integration
 * @param propertyName
 * @param value
 */


function setIntegrationProperty(integration, propertyName, value) {
  var obj;

  if (!propertyName) {
    return integration;
  }

  return Object.assign({}, integration, (obj = {}, obj[propertyName] = value, obj));
}

function createStep() {
  return {
    id: utils.key()
  };
}

function createConnectionStep() {
  var step = createStep();
  step.stepKind = 'endpoint';
  return step;
}
/**
 * Creates a step object using the supplied connection
 * @param connection
 */


function createStepWithConnection(connection) {
  return Object.assign({}, createStep(), {
    stepKind: ENDPOINT,
    connection: connection
  });
}
/**
 * Adds the supplied metadata to the step, adding to any existing metadata
 * @param step
 * @param metadata
 */


function addMetadataToStep(step, metadata) {
  if (!metadata || !step) {
    return step;
  }

  var combinedMetadata = Object.assign({}, step.metadata, metadata);
  return Object.assign({}, step, {
    metadata: combinedMetadata
  });
}
/**
 * Sets the datashape on a step in the specified direction, preserving any existing configuration
 * @param step
 * @param dataShape
 * @param isInput
 */


function setDataShapeOnStep(step, dataShape, isInput) {
  var obj;

  if (!step || !dataShape) {
    return step;
  }

  var prop = isInput ? 'inputDataShape' : 'outputDataShape';
  var action = step.action ? Object.assign({}, step.action) : {};
  var descriptor = Object.assign({}, action.descriptor, (obj = {}, obj[prop] = dataShape, obj));
  return Object.assign({}, step, {
    action: Object.assign({}, action, {
      descriptor: Object.assign({}, descriptor)
    })
  });
}
/**
 * Sets the configured properties on the step
 * @param step
 * @param configuredProperties
 */


function setConfiguredPropertiesOnStep(step, configuredProperties) {
  return Object.assign({}, step, {
    configuredProperties: stringifyValues(configuredProperties)
  });
}
/**
 * Sets the action on the given step if it's not set or different
 * @param step
 * @param action
 * @param stepKind
 */


function setActionOnStep(step, action, stepKind) {
  if (stepKind === void 0) stepKind = ENDPOINT; // if the step has an action, only set it if the new action is different

  if (step.action && step.action.id === action.id) {
    return step;
  }

  return Object.assign({}, step, {
    stepKind: stepKind,
    action: action
  });
}
/**
 * Sets the descriptor on the step, preserving user defined data shapes and setting any config defaults
 * @param step
 * @param descriptor
 */


function setDescriptorOnStep(step, descriptor) {
  if (!step) {
    return step;
  } // If the step doesn't have an action but we're trying to set a data shape on it, it's probably an extension or something


  if (!step.action) {
    return Object.assign({}, step, {
      action: {
        actionType: 'step',
        descriptor: descriptor
      }
    });
  }

  var propertyDefaults = getPropertyDefaults(descriptor.propertyDefinitionSteps); // Technically this shouldn't actually be a condition, but for safety's sake...

  if (!step.action.descriptor) {
    return Object.assign({}, {
      configuredProperties: propertyDefaults
    }, step, {
      action: Object.assign({}, step.action, {
        descriptor: descriptor
      })
    });
  } // Update the step's configured properties with any defaults in the descriptor


  var configuredProperties = Object.assign({}, propertyDefaults || {}, step.configuredProperties || {});
  return Object.assign({}, step, {
    action: applyUserDefinedDataShapesToAction(step.action, Object.assign({}, step.action, {
      descriptor: descriptor
    })),
    configuredProperties: configuredProperties
  });
}
/**
 * Copies user-defined data shapes from an old copy to a new copy of the action
 * @param oldAction
 * @param newAction
 */


function applyUserDefinedDataShapesToAction(oldAction, newAction) {
  if (!oldAction) {
    return newAction;
  }

  var descriptor = newAction.descriptor;
  var oldDescriptor = oldAction.descriptor;
  return setDescriptorOnAction(newAction, oldDescriptor, descriptor);
}
/**
 * Compares the old and new descriptors and returns a new action object
 * with user defined data shapes preserved
 * @param action
 * @param oldDescriptor
 * @param descriptor
 */


function setDescriptorOnAction(action, oldDescriptor, descriptor) {
  var oldInputDataShape = oldDescriptor.inputDataShape;
  var oldOutputDataShape = oldDescriptor.outputDataShape;
  var preserveInput = isUserDefinedDataShape(oldInputDataShape) || descriptor.inputDataShape && descriptor.inputDataShape.kind && toDataShapeKinds(descriptor.inputDataShape.kind) !== exports.DataShapeKinds.NONE && !descriptor.inputDataShape.specification;
  var preserveOutput = isUserDefinedDataShape(oldOutputDataShape) || descriptor.outputDataShape && descriptor.outputDataShape.kind && toDataShapeKinds(descriptor.outputDataShape.kind) !== exports.DataShapeKinds.NONE && !descriptor.outputDataShape.specification;
  return Object.assign({}, action, {
    descriptor: Object.assign({}, descriptor, {
      inputDataShape: preserveInput ? oldInputDataShape : descriptor.inputDataShape,
      outputDataShape: preserveOutput ? oldOutputDataShape : descriptor.outputDataShape
    })
  });
}
/**
 * Prepare the configuration for the backend which supports only numbers and strings
 * @param configuredProperties
 */


function stringifyValues(configuredProperties) {
  if (!configuredProperties) {
    return configuredProperties;
  }

  return Object.keys(configuredProperties).reduce(function (props, name) {
    var obj, obj$1;
    var value = configuredProperties[name];

    switch (typeof value) {
      case 'string':
      case 'number':
        return Object.assign({}, props, (obj = {}, obj[name] = value, obj));

      default:
        return Object.assign({}, props, (obj$1 = {}, obj$1[name] = JSON.stringify(value), obj$1));
    }
  }, {});
}
/**
 * Performs final checks and tweaks to the integration object, use before posting to the backend
 * @param integration
 */


function prepareIntegrationForSaving(integration) {
  var id = integration.id;
  var flows = validateFlows(integration.flows);
  var tags = buildTags(integration.flows, integration.tags);
  return Object.assign({}, integration, {
    flows: flows,
    id: id === NEW_INTEGRATION_ID ? undefined : id,
    tags: tags
  });
}

function getFlow(integration, flowId) {
  // TODO some code relies on these semantics
  if (!integration || !integration.flows || !flowId) {
    return undefined;
  }

  return integration.flows.find(function (flow) {
    return flow.id === flowId;
  });
}

function reconcileConditionalFlows(integration, newFlows, stepId, descriptor) {
  var flowsWithoutStepId = getFlowsWithoutLinkedStepId(integration.flows, stepId);
  var updatedFlows = newFlows.map(function (flow) {
    var newStep = setDataShapeOnStep(Object.assign({}, flow.steps[0]), descriptor.outputDataShape, false);
    return applyUpdatedStep(flow, newStep, 0);
  });
  return Object.assign({}, integration, {
    flows: flowsWithoutStepId.concat(updatedFlows)
  });
}

function getFlowsWithoutLinkedStepId(flows, stepId) {
  return flows.filter(function (flow) {
    return flow.type === exports.FlowType.PRIMARY || flow.type === exports.FlowType.API_PROVIDER || getMetadataValue(STEP_ID_METADATA_KEY, flow.metadata) !== stepId;
  });
}
/**
 * Inserts the supplied step into the indicated flow after the given position
 * @param integration
 * @param flowId
 * @param step
 * @param position
 * @param getSanitizedSteps
 */


function insertStepIntoFlowAfter(integration, flowId, step, position, getSanitizedSteps) {
  var flow = getFlow(integration, flowId);
  var steps = insertStepAfter(flow.steps, step, position);
  return setFlow(integration, Object.assign({}, flow, {
    steps: steps
  }), getSanitizedSteps);
}
/**
 * Inserts the supplied step into the indicated flow before the given position
 * @param integration
 * @param flowId
 * @param step
 * @param position
 * @param getSanitizedSteps
 */


function insertStepIntoFlowBefore(integration, flowId, step, position, getSanitizedSteps) {
  var flow = getFlow(integration, flowId);
  var steps = insertStepBefore(flow.steps, step, position);
  return setFlow(integration, Object.assign({}, flow, {
    steps: steps
  }), getSanitizedSteps);
}
/**
 * Overwrites the supplied step at the given position into the flow
 * @param integration
 * @param flowId
 * @param step
 * @param position
 * @param getSanitizedSteps
 */


function setStepInFlow(integration, flowId, step, position, getSanitizedSteps) {
  var flow = getFlow(integration, flowId);
  return setFlow(integration, applyUpdatedStep(flow, step, position), getSanitizedSteps);
}
/**
 * Returns a new flow object with the supplied step set at the given position
 * @param flow
 * @param step
 * @param position
 */


function applyUpdatedStep(flow, step, position) {
  var steps = [].concat(flow.steps);

  if (typeof step.id === 'undefined') {
    step.id = utils.key();
  }

  steps[position] = Object.assign({}, step);
  return Object.assign({}, flow, {
    steps: steps
  });
}
/**
 * Removes the step at the given position in the supplied flow
 * @param integration
 * @param flowId
 * @param position
 * @param getSanitizedSteps
 */


function removeStepFromFlow(integration, flowId, position, getSanitizedSteps) {
  var flow = getFlow(integration, flowId);
  var steps = getSteps(integration, flowId);
  var toDelete = getStep(integration, flowId, position); // special handling for conditional flows, related flows need
  // to be removed from the integration as well.

  var flows = toDelete.stepKind === CHOICE ? getFlowsWithoutLinkedStepId(integration.flows, toDelete.id) : integration.flows;

  if (position === getFirstPosition(integration, flowId) || position === getLastPosition(integration, flowId)) {
    steps[position] = createStep();
    steps[position].stepKind = ENDPOINT;
  } else {
    steps.splice(position, 1);
  }

  return setFlow(Object.assign({}, integration, {
    flows: flows
  }), Object.assign({}, flow, {
    steps: steps
  }), getSanitizedSteps);
}
/**
 * Inserts the supplied step after the position
 * @param steps
 * @param step
 * @param position
 */


function insertStepAfter(steps, step, position) {
  return insertStepBefore(steps, step, position + 1);
}
/**
 * Inserts the supplied step before the position
 * @param steps
 * @param step
 * @param position
 */


function insertStepBefore(steps, step, position) {
  var ref;
  return (ref = []).concat.apply(ref, steps.slice(0, position).concat([step], steps.slice(position)));
} //
// /**
//  * Creates a new step, using any default values supplied for the given step kind
//  * @param store
//  * @param stepKind
//  */
// export function createStepUsingStore(store: StepStore, stepKind?: string) {
//   const stepConfig = store.getDefaultStepDefinition(stepKind);
//   return { ...createStep(), ...stepConfig, ...{ id: key(), stepKind } };
// }

/**
 * Creates a new empty flow object
 * @param id
 */


function createFlowWithId(id) {
  return {
    id: id,
    steps: [createConnectionStep(), createConnectionStep()]
  };
}
/**
 * Create a new alternate flow and relate it to the supplied step
 * @param name
 * @param description
 * @param kind
 * @param primaryFlowId
 * @param flowConnectionTemplate
 * @param step
 * @param useId - ID to use instead of generating one
 */


function createConditionalFlow(name, description, kind, primaryFlowId, flowConnectionTemplate, step, useId) {
  var obj;

  if (typeof step.id === 'undefined') {
    throw Error('Cannot create conditional flow for a step with no ID set');
  }

  var flowId = useId || utils.key();
  return {
    connections: [],
    description: description,
    id: flowId,
    metadata: (obj = {}, obj[EXCERPT_METADATA_KEY] = '', obj[FLOW_KIND_METADATA_KEY] = kind, obj[PRIMARY_FLOW_ID_METADATA_KEY] = primaryFlowId, obj[STEP_ID_METADATA_KEY] = step.id, obj),
    name: name,
    steps: [createConditionalFlowStart(flowId, flowConnectionTemplate, step), createConditionalFlowEnd(flowConnectionTemplate)],
    type: exports.FlowType.ALTERNATE
  };
}
/**
 * Returns the start of the step array or undefined if it's not set up
 * @param integration
 * @param flowId
 */


function getFirstPosition(integration, flowId) {
  if (!flowId) {
    return undefined;
  }

  var flow = getFlow(integration, flowId); // TODO preserving semantics for some legacy code

  return typeof flow.steps !== 'undefined' ? 0 : undefined;
}
/**
 * Returns the last index of the step array of the given flow or undefined if it hasn't been created
 * @param integration
 * @param flowId
 */


function getLastPosition(integration, flowId) {
  if (!flowId) {
    return undefined;
  }

  var flow = getFlow(integration, flowId); // TODO preserve this block for now

  if (!flow.steps) {
    return undefined;
  }

  if (flow.steps.length <= 1) {
    return 1;
  }

  return flow.steps.length - 1;
}

function getStepsLastPosition(steps) {
  if (steps.length <= 1) {
    return 1;
  }

  return steps.length - 1;
}
/**
 * Returns an index in between the first and last step of the given flow
 * @param integration
 * @param flowId
 */


function getMiddlePosition(integration, flowId) {
  var position = getLastPosition(integration, flowId);
  return typeof position !== 'undefined' ? Math.round(position / 2) : undefined;
}
/**
 * Returns a copy of the step in the desired flow at the given position
 * @param integration
 * @param flowId
 * @param position
 */


function getStep(integration, flowId, position) {
  var flow = getFlow(integration, flowId);

  if (!flow) {
    // TODO following semantics for now, this should throw an error
    return undefined;
  }

  var step = flow.steps[position];
  return typeof step !== 'undefined' ? Object.assign({}, step) : undefined;
}
/**
 * Returns a copy of the first step in the flow
 * @param integration
 * @param flowId
 */


function getStartStep(integration, flowId) {
  return getStep(integration, flowId, getFirstPosition(integration, flowId));
}
/**
 * Returns a copy of the last step in the flow
 * @param integration
 * @param flowId
 */


function getLastStep(integration, flowId) {
  return getStep(integration, flowId, getLastPosition(integration, flowId));
}
/**
 * Get an array of middle steps from the given flow, or an empty array if there's only a start/end step
 * @param integration
 * @param flowId
 */


function getMiddleSteps(integration, flowId) {
  if (getLastPosition(integration, flowId) < 2) {
    // TODO there's no middle steps maybe this should be undefined but following current semantics for now
    return [];
  }

  var flow = getFlow(integration, flowId);

  if (!flow || !flow.steps) {
    // TODO following semantics for now, this should be an error
    return [];
  }

  return flow.steps.slice(1, -1);
}
/**
 * Get an array of steps from the flow after the given position
 * @param integration
 * @param flowId
 * @param position
 */


function getIntegrationSubsequentSteps(integration, flowId, position) {
  var steps = getSteps(integration, flowId);
  return getSubsequentSteps(steps, position);
}
/**
 * Get an array of steps from the flow after the given position
 * @param steps
 * @param position
 */


function getSubsequentSteps(steps, position) {
  return steps.slice(position + 1);
}
/**
 * Get an array of steps from the flow before the given position
 * @param integration
 * @param flowId
 * @param position
 */


function getPreviousIntegrationSteps(integration, flowId, position) {
  var steps = getSteps(integration, flowId);
  return getPreviousSteps(steps, position);
}
/**
 * Get an array of steps from the flow before the given position
 * @param steps
 * @param position
 */


function getPreviousSteps(steps, position) {
  return steps.slice(0, position);
}
/**
 * Returns all connections after the specified position
 * @param integration
 * @param flowId
 * @param position
 */


function getSubsequentConnections(integration, flowId, position) {
  var steps = getIntegrationSubsequentSteps(integration, flowId, position);

  if (steps) {
    return steps.filter(function (s) {
      return s.stepKind === ENDPOINT;
    });
  } // TODO this seems like an odd thing to do, but preserving semantics for now


  return null;
}
/**
 * Return all connections before the given position
 * @param integration
 * @param flowId
 * @param position
 */


function getPreviousConnections(integration, flowId, position) {
  var steps = getPreviousIntegrationSteps(integration, flowId, position);

  if (steps) {
    return steps.filter(function (s) {
      return s.stepKind === ENDPOINT;
    });
  } // TODO this seems like an odd thing to do, but preserving semantics for now


  return null;
}
/**
 * Return the first connection before the given position
 * @param integration
 * @param flowId
 * @param position
 */


function getPreviousConnection(integration, flowId, position) {
  var prevConns = getPreviousConnections(integration, flowId, position) || [];
  return prevConns[prevConns.length - 1];
}
/**
 * Return the first connection after the given position
 * @param integration
 * @param flowId
 * @param position
 */


function getSubsequentConnection(integration, flowId, position) {
  return (getSubsequentConnections(integration, flowId, position) || [])[0];
}
/**
 * Returns an array of all steps after the given position that contain a data shape
 * @param integration
 * @param flowId
 * @param position
 */


function getSubsequentIntegrationStepsWithDataShape(integration, flowId, position) {
  var steps = getIntegrationSubsequentSteps(integration, flowId, position);

  if (steps) {
    return steps.map(function (step, index) {
      return {
        step: step,
        index: position + index
      };
    }).filter(function (indexedStep) {
      return hasDataShape(indexedStep.step, true);
    });
  } // TODO preserving semantics for now


  return [];
}
/**
 * Return all steps before the given position that have a data shape
 * @param integration
 * @param flowId
 * @param position
 */


function getPreviousIntegrationStepsWithDataShape(integration, flowId, position) {
  var steps = getSteps(integration, flowId);
  return getPreviousStepsWithDataShape(steps || [], position);
}
/**
 * Return all steps before the given position that have a data shape
 * @param steps
 * @param position
 */


function getPreviousStepsWithDataShape(steps, position) {
  var previousSteps = getPreviousSteps(steps, position);

  if (previousSteps) {
    return previousSteps.map(function (step, index) {
      return {
        step: step,
        index: index
      };
    }).filter(function (indexedStep) {
      return hasDataShape(indexedStep.step, false);
    });
  } // TODO preserving semantics for now


  return [];
}
/**
 * Returns the index of the previous step that has a data shape
 * @param integration
 * @param flowId
 * @param position
 */


function getPreviousIntegrationStepIndexWithDataShape(integration, flowId, position) {
  var steps = getPreviousIntegrationStepsWithDataShape(integration, flowId, position);

  if (steps && steps.length) {
    return steps[steps.length - 1].index;
  }

  return -1;
}
/**
 * Returns the first previous step that has a data shape
 * @param integration
 * @param flowId
 * @param position
 */


function getPreviousIntegrationStepWithDataShape(integration, flowId, position) {
  var steps = getSteps(integration, flowId);
  return getPreviousStepWithDataShape(steps || [], position);
}
/**
 * Returns the first previous step that has a data shape
 * @param steps
 * @param position
 */


function getPreviousStepWithDataShape(steps, position) {
  var previousSteps = getPreviousStepsWithDataShape(steps, position);

  if (previousSteps && previousSteps.length) {
    return previousSteps[previousSteps.length - 1].step;
  }

  return undefined;
}
/**
 * Returns the next step after the given position that contains a data shape
 * @param integration
 * @param flowId
 * @param position
 */


function getSubsequentIntegrationStepWithDataShape(integration, flowId, position) {
  var steps = getSubsequentIntegrationStepsWithDataShape(integration, flowId, position);

  if (steps && steps.length) {
    return steps[0].step;
  }

  return undefined;
}

(function (FlowErrorKind) {
  FlowErrorKind[FlowErrorKind["NO_START_CONNECTION"] = 0] = "NO_START_CONNECTION";
  FlowErrorKind[FlowErrorKind["NO_FINISH_CONNECTION"] = 1] = "NO_FINISH_CONNECTION";
  FlowErrorKind[FlowErrorKind["NO_NAME"] = 2] = "NO_NAME";
})(exports.FlowErrorKind || (exports.FlowErrorKind = {}));
/**
 * Inspects the indicated flow by ID and returns an array of possible issues with it
 * @param integration
 * @param flowId
 */


function validateFlow(integration, flowId) {
  var errors = [];

  if (!flowId) {
    throw new Error('Invalid flow ID specified');
  }

  if (!integration) {
    throw new Error('Invalid integration object given');
  }

  var startStep = getStartStep(integration, flowId);

  if (typeof startStep === 'undefined' || typeof startStep.stepKind === 'undefined' || typeof startStep.connection === 'undefined' && startStep.stepKind === ENDPOINT) {
    errors.push({
      kind: exports.FlowErrorKind.NO_START_CONNECTION
    });
  }

  var endStep = getLastStep(integration, flowId);

  if (typeof endStep === 'undefined' || typeof endStep.stepKind === 'undefined' || endStep.stepKind === ENDPOINT && typeof endStep.connection === 'undefined') {
    errors.push({
      kind: exports.FlowErrorKind.NO_FINISH_CONNECTION
    });
  }

  return errors;
}
/**
 * Finds the closest step of type 'Aggregate' after the provided position.
 * @param integration
 * @param flowId
 * @param position
 */


function getIntegrationNextAggregateStep(integration, flowId, position) {
  var steps = getIntegrationSubsequentSteps(integration, flowId, position);
  return getNextAggregateStep(steps || [], position);
}
/**
 * Finds the closest step of type 'Aggregate' after the provided position.
 * @param steps
 * @param position
 */


function getNextAggregateStep(steps, position) {
  var subsequentSteps = getSubsequentSteps(steps, position);

  if (subsequentSteps && subsequentSteps.length) {
    return subsequentSteps.filter(function (s) {
      return s.stepKind === AGGREGATE;
    })[0];
  }

  return undefined;
}
/**
 * Returns if the given indice is at the start of the flow
 * @param integration
 * @param flowId
 * @param position
 */


function isStartStep(integration, flowId, position) {
  return position === 0;
}
/**
 * Returns if the given indice is at the end of the flow
 * @param integration
 * @param flowId
 * @param position
 */


function isEndStep(integration, flowId, position) {
  var steps = getSteps(integration, flowId);
  return atEnd(steps, position);
}
/**
 * Returns if the given indice is at the end of the step array
 * @param steps
 * @param position
 */


function atEnd(steps, position) {
  return position + 1 >= steps.length;
}
/**
 * Returns if the given indice is somewhere in the middle of the flow
 * @param integration
 * @param flowId
 * @param position
 */


function isMiddleStep(integration, flowId, position) {
  return !isStartStep(integration, flowId, position) && !isEndStep(integration, flowId, position);
}
/**
 * Creates the start connection for a conditional flow
 * @param flowId
 * @param connection
 * @param thisStep
 */


function createConditionalFlowStart(flowId, connection, thisStep) {
  var step = Object.assign({}, createStepWithConnection(connection), {
    action: getConnectorAction('io.syndesis:flow-start', connection),
    configuredProperties: {
      name: flowId
    },
    description: '',
    metadata: {
      configured: 'true'
    },
    name: 'Flow start',
    properties: {}
  });
  return adaptOutputShape(thisStep, step);
}
/**
 * Creates the end connection for a conditional flow
 * @param connection
 */


function createConditionalFlowEnd(connection) {
  return Object.assign({}, createStepWithConnection(connection), {
    action: getConnectorAction('io.syndesis:flow-end', connection),
    description: '',
    metadata: {
      configured: 'true'
    },
    name: 'Flow end',
    properties: {}
  });
}
/**
 * Accessor helper function to get the given action out of a connection's connector
 * @param id
 * @param connection
 */


function getConnectorAction(id, connection) {
  return connection.connector.actions.find(function (action) {
    return action.id === id;
  });
}
/**
 * Helper function to ensure a conditional flow step assumes the correct
 * output shape that reflects the required input shape it's being inserted
 * in front of.
 * @param thisStep
 * @param step
 */


function adaptOutputShape(thisStep, step) {
  if (thisStep && thisStep.action && thisStep.action.descriptor && thisStep.action.descriptor.inputDataShape) {
    step.action.descriptor.outputDataShape = thisStep.action.descriptor.inputDataShape;
  }

  return step;
}
/**
 * Helper function to deal with the metdata map for a given thing that can
 * have a metadata map or not.
 * @param mapKey
 * @param metadata
 * @param defaultValue - value to return if the key isn't set in the map
 */


function getMetadataValue(mapKey, metadata, defaultValue) {
  return typeof metadata !== 'undefined' ? metadata[mapKey] : defaultValue;
}
/**
 * Returns true if the given integration is an API provider integration
 * @param integration
 */


function isIntegrationApiProvider(integration) {
  return (integration.tags || []).includes(API_PROVIDER);
}
/**
 * Returns true if the given flow is the primary flow for an integration
 * @param flow
 */


function isPrimaryFlow(flow) {
  return typeof flow !== 'undefined' && (typeof flow.type === 'undefined' || flow.type === exports.FlowType.PRIMARY || flow.type === exports.FlowType.API_PROVIDER);
}
/**
 * Returns true if the given flow is an alternate flow, created by the conditional flow step
 * @param flow
 */


function isAlternateFlow(flow) {
  if (typeof flow.type !== 'undefined') {
    return flow.type === exports.FlowType.ALTERNATE;
  }

  var step = (flow.steps || [])[0];

  try {
    return step.connection.connectorId === FLOW;
  } catch (e) {// ignore
  }

  return false;
}
/**
 * Returns true if the given flow is a conditional flow created from a conditional flow step
 * @param flow
 */


function isConditionalFlow(flow) {
  return isAlternateFlow(flow) && getMetadataValue('kind', flow.metadata) === exports.FlowKind.CONDITIONAL;
}
/**
 * Returns true if the given flow is the default flow for a conditional flow step
 * @param flow
 */


function isDefaultFlow(flow) {
  return isAlternateFlow(flow) && getMetadataValue(FLOW_KIND_METADATA_KEY, flow.metadata) === exports.FlowKind.DEFAULT;
}
/**
 * Returns true if the given flow is an API provider flow
 * @param flow
 */


function isApiProviderFlow(flow) {
  var step = (flow.steps || [])[0];

  try {
    return step.connection.connectorId === API_PROVIDER;
  } catch (e) {// ignore
  }

  return false;
}
/**
 * Returns all API provider flows in the given integration
 * @param integration
 */


function getApiProviderFlows(integration) {
  return (integration.flows || []).filter(isApiProviderFlow);
}
/**
 * Returns all conditional flows in the given integration
 * @param integration
 */


function getConditionalFlows(integration) {
  return (integration.flows || []).filter(isConditionalFlow);
}
/**
 * Returns all default flows in the given integration, there should only be one however
 * @param integration
 */


function getDefaultFlow(integration) {
  return (integration.flows || []).filter(isDefaultFlow);
}

function getConditionalFlowGroups(integration) {
  // Add default flows to the very end of the list, ensures that default flows are always at the end of a group
  var conditionalFlows = getConditionalFlows(integration).concat(getDefaultFlow(integration)); // potentially we have many flows that belong to different steps, so group flows by step id

  var flowGroups = [];
  conditionalFlows.forEach(function (flow) {
    var stepId = getMetadataValue('stepId', flow.metadata);
    var flowGroup = flowGroups.find(function (group) {
      return group.id === stepId;
    });

    if (flowGroup) {
      flowGroup.flows.push(flow);
    } else {
      flowGroups.push({
        id: stepId,
        flows: [flow]
      });
    }
  });
  return flowGroups;
}

function getConditionalFlowGroupsFor(integration, primaryId) {
  var flowGroups = getConditionalFlowGroups(integration);
  return flowGroups.filter(function (group) {
    return getPrimaryFlowId(integration, group.flows[0]) === primaryId;
  });
}

function getPrimaryFlowId(integration, flow) {
  return getMetadataValue('primaryFlowId', flow.metadata, integration.flows[0].id);
}

var serializeIntegration = function serializeIntegration(i) {
  return btoa(encodeURIComponent(JSON.stringify(i)));
};

var deserializeIntegration = function deserializeIntegration(i) {
  return JSON.parse(decodeURIComponent(atob(i)));
};

var ServerEventsContextDefaultValue = {};
var ServerEventsContext = React.createContext(ServerEventsContextDefaultValue);

var Stream =
/*@__PURE__*/
function (Fetch$$1) {
  function Stream() {
    var _this = this;

    Fetch$$1.apply(this, arguments);

    this.read = function () {
      try {
        try {
          _this.setState({
            loading: true
          });

          callFetch({
            contentType: _this.props.contentType,
            headers: _this.props.headers,
            method: 'GET',
            url: "" + _this.props.baseUrl + _this.props.url
          }).then(function (response) {
            return response.body;
          }).then(function (body) {
            _this.reader = body.getReader();
            var textDecoder = new TextDecoder('utf-8');

            var pushData = function pushData(ref) {
              var done = ref.done;
              var value = ref.value;

              if (done) {
                _this.setState({
                  loading: false
                });
              } else {
                _this.setState({
                  data: (_this.state.data || []).concat([textDecoder.decode(value)])
                });

                _this.reader.read().then(pushData);
              }
            };

            _this.reader.read().then(pushData);
          });
        } catch (e) {
          _this.setState({
            error: true,
            errorMessage: e.message,
            loading: false
          });
        }

        return;
      } catch (e) {
        return Promise.reject(e);
      }
    };

    this.onSave = function () {
      try {
        throw new Error("Can't save from a stream");
      } catch (e) {
        return Promise.reject(e);
      }
    };
  }

  if (Fetch$$1) Stream.__proto__ = Fetch$$1;
  Stream.prototype = Object.create(Fetch$$1 && Fetch$$1.prototype);
  Stream.prototype.constructor = Stream;

  Stream.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    try {
      var _this2 = this;

      if (prevProps.url !== _this2.props.url) {
        if (_this2.reader) {
          _this2.reader.cancel();
        }

        _this2.read();
      }
    } catch (e) {
      return Promise.reject(e);
    }
  };

  Stream.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.reader) {
      this.reader.cancel();
    }
  };

  return Stream;
}(Fetch);

function objectWithoutProperties$1(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

var SyndesisFetch =
/*@__PURE__*/
function (superclass) {
  function SyndesisFetch() {
    superclass.apply(this, arguments);
  }

  if (superclass) SyndesisFetch.__proto__ = superclass;
  SyndesisFetch.prototype = Object.create(superclass && superclass.prototype);
  SyndesisFetch.prototype.constructor = SyndesisFetch;

  SyndesisFetch.prototype.render = function render() {
    var ref = this.props;
    var url = ref.url;
    var stream = ref.stream;
    var rest = objectWithoutProperties$1(ref, ["url", "stream"]);
    var props = rest;
    var FetchOrStream = stream ? Stream : Fetch;
    return React.createElement(ApiContext.Consumer, null, function (ref) {
      var apiUri = ref.apiUri;
      var headers = ref.headers;
      return React.createElement(FetchOrStream, Object.assign({
        baseUrl: apiUri,
        url: url,
        headers: Object.assign({}, props.headers || headers)
      }, props));
    });
  };

  return SyndesisFetch;
}(React.Component);

function useApiConnectorSummary(specification) {
  var apiContext = React.useContext(ApiContext);
  var ref = React.useState(true);
  var loading = ref[0];
  var setLoading = ref[1];
  var ref$1 = React.useState(false);
  var error = ref$1[0];
  var setError = ref$1[1];
  var ref$2 = React.useState(undefined);
  var apiSummary = ref$2[0];
  var setApiSummary = ref$2[1];
  React.useEffect(function () {
    var fetchSummary = function fetchSummary() {
      try {
        setLoading(true);
        return Promise.resolve(_finallyRethrows(function () {
          return _catch(function () {
            return Promise.resolve(callFetch({
              body: {
                configuredProperties: {
                  specification: specification
                },
                connectorTemplateId: 'swagger-connector-template'
              },
              headers: apiContext.headers,
              includeAccept: true,
              includeContentType: true,
              method: 'POST',
              url: apiContext.apiUri + "/connectors/custom/info"
            })).then(function (response) {
              return Promise.resolve(response.json()).then(function (summary) {
                if (summary.errorCode || summary.errors) {
                  throw new Error(summary.userMsg || (summary.errors || []).map(function (e) {
                    return e.message;
                  }).filter(function (m) {
                    return m;
                  }).join('\n'));
                }

                setApiSummary(summary);
              });
            });
          }, function (e) {
            setError(e);
          });
        }, function (_wasThrown, _result) {
          setLoading(false);

          if (_wasThrown) {
            throw _result;
          }

          return _result;
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    };

    fetchSummary();
  }, [specification, apiContext, setLoading, setApiSummary, setError]);
  return {
    apiSummary: apiSummary,
    loading: loading,
    error: error
  };
}

function useApiProviderSummary(specification) {
  var apiContext = React.useContext(ApiContext);
  var ref = React.useState(true);
  var loading = ref[0];
  var setLoading = ref[1];
  var ref$1 = React.useState(false);
  var error = ref$1[0];
  var setError = ref$1[1];
  var ref$2 = React.useState(undefined);
  var apiSummary = ref$2[0];
  var setApiSummary = ref$2[1];
  React.useEffect(function () {
    var fetchSummary = function fetchSummary() {
      try {
        setLoading(true);
        return Promise.resolve(_finallyRethrows(function () {
          return _catch(function () {
            var body = new FormData();
            body.append('specification', specification);
            return Promise.resolve(callFetch({
              body: body,
              headers: apiContext.headers,
              includeAccept: true,
              includeContentType: false,
              method: 'POST',
              url: apiContext.apiUri + "/apis/info"
            })).then(function (response) {
              return Promise.resolve(response.json()).then(function (summary) {
                if (summary.errorCode && summary.errors) {
                  throw new Error(summary.userMsg || (summary.errors || []).map(function (e) {
                    return e.message;
                  }).filter(function (m) {
                    return m;
                  }).join('\n'));
                }

                setApiSummary(summary);
              });
            });
          }, function (e) {
            setError(e);
          });
        }, function (_wasThrown, _result) {
          setLoading(false);

          if (_wasThrown) {
            throw _result;
          }

          return _result;
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    };

    fetchSummary();
  }, [specification, apiContext, setLoading, setApiSummary, setError]);
  return {
    apiSummary: apiSummary,
    loading: loading,
    error: error
  };
}

var useConnectionHelpers = function useConnectionHelpers() {
  var apiContext = React.useContext(ApiContext);

  var createConnection = function createConnection(connector, name, description, configuredProperties) {
    var connection = {};
    return produce(connection, function (draft) {
      draft.name = name;
      draft.description = description;
      draft.configuredProperties = configuredProperties;
      draft.connector = connector;
      draft.connectorId = connector.id;
      draft.icon = connector.icon;
    });
  };

  var deleteConnection = function deleteConnection(connectionId) {
    try {
      return Promise.resolve(callFetch({
        headers: apiContext.headers,
        method: 'DELETE',
        url: apiContext.apiUri + "/connections/" + connectionId
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        return Promise.resolve();
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var updateConnection = function updateConnection(connection, name, description, configuredProperties) {
    return produce(connection, function (draft) {
      draft.name = name || draft.name; // allow empty descriptions

      draft.description = description === undefined ? draft.description : description;
      draft.configuredProperties = configuredProperties || draft.configuredProperties;
    });
  };

  var validateConfiguration = function validateConfiguration(connectorId, values) {
    try {
      return Promise.resolve(callFetch({
        body: values,
        headers: apiContext.headers,
        method: 'POST',
        url: apiContext.apiUri + "/connectors/" + connectorId + "/verifier"
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        return Promise.resolve(response.json());
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var saveConnection = function saveConnection(connection) {
    try {
      return Promise.resolve(produce(connection, function (draft) {
        try {
          return Promise.resolve(callFetch({
            body: draft,
            headers: apiContext.headers,
            method: draft.id ? 'PUT' : 'POST',
            url: draft.id ? apiContext.apiUri + "/connections/" + draft.id : apiContext.apiUri + "/connections"
          })).then(function (response) {
            if (!response.ok) {
              throw new Error(response.statusText);
            }

            var _temp = !draft.id;

            return _temp ? Promise.resolve(response.json()) : Promise.resolve(draft);
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var validateName = function validateName(connection, proposedName) {
    try {
      // short circuit if name has not changed
      if (connection.name === proposedName) {
        return Promise.resolve({
          isError: false
        });
      }

      var testConn = {
        name: proposedName
      };
      return Promise.resolve(callFetch({
        body: testConn,
        headers: apiContext.headers,
        method: 'POST',
        url: apiContext.apiUri + "/connections/validation"
      })).then(function (response) {
        return response.ok ? {
          isError: false
        } : Promise.resolve(response.json()).then(function (result) {
          return Object.assign({}, {
            isError: true
          }, result[0]);
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return {
    createConnection: createConnection,
    deleteConnection: deleteConnection,
    saveConnection: saveConnection,
    updateConnection: updateConnection,
    validateConfiguration: validateConfiguration,
    validateName: validateName
  };
};

function objectWithoutProperties$2(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

function useApiResource(ref) {
  var body = ref.body;
  var url = ref.url;
  var defaultValue = ref.defaultValue;
  var method = ref.method;
  if (method === void 0) method = 'GET';
  var initialValue = ref.initialValue;
  var transformResponse = ref.transformResponse;
  if (transformResponse === void 0) transformResponse = function transformResponse(r) {
    try {
      return Promise.resolve(r.json());
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var readOnMount = ref.readOnMount;
  if (readOnMount === void 0) readOnMount = true;

  var fetchResource = function fetchResource(ref) {
    if (ref === void 0) ref = {
      body: body,
      url: url,
      method: method
    };
    var fBody = ref.body;
    var fUrl = ref.url;
    var fHeaders = ref.headers;
    var fMethod = ref.method;
    var rest = objectWithoutProperties$2(ref, ["body", "url", "headers", "method"]);
    var props = rest;

    try {
      var r = null;
      setLoading(true);

      var _temp = _finallyRethrows(function () {
        return _catch(function () {
          return Promise.resolve(callFetch(Object.assign({}, props || {}, {
            body: fBody,
            headers: Object.assign({}, apiContext.headers, fHeaders || {}),
            method: fMethod,
            url: "" + apiContext.apiUri + fUrl
          }))).then(function (response) {
            if (!response.ok) {
              throw new Error(response.statusText);
            }

            return Promise.resolve(transformResponse(response)).then(function (_transformResponse) {
              r = _transformResponse;
              setResource(r);
              setHasData(true);
            });
          });
        }, function (e) {
          setHasData(false);
          setError(e);
        });
      }, function (_wasThrown, _result) {
        setLoading(false);

        if (_wasThrown) {
          throw _result;
        }

        return _result;
      });

      return Promise.resolve(_temp && _temp.then ? _temp.then(function (_result) {
        return r;
      }) : r);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var apiContext = React.useContext(ApiContext);
  var ref$1 = React.useState(readOnMount);
  var loading = ref$1[0];
  var setLoading = ref$1[1];
  var ref$2 = React.useState(!!initialValue);
  var hasData = ref$2[0];
  var setHasData = ref$2[1];
  var ref$3 = React.useState(false);
  var error = ref$3[0];
  var setError = ref$3[1];
  var ref$4 = React.useState(initialValue || defaultValue);
  var resource = ref$4[0];
  var setResource = ref$4[1];
  var previousUrl = React.useRef();
  var read = React.useCallback(fetchResource, [callFetch, apiContext, url, setLoading, setResource, setError, setHasData, body]);
  React.useEffect(function () {
    if (previousUrl.current !== url && readOnMount) {
      read();
      previousUrl.current = url;
    }
  }, [url, previousUrl, read, readOnMount]);
  return {
    resource: resource,
    loading: loading,
    error: error,
    hasData: hasData,
    read: read
  };
}

var transformConnectionResponse = function transformConnectionResponse(connection) {
  return Object.assign({}, connection, {
    actionsWithFrom: getActionsWithFrom(connection.connector ? connection.connector.actions : []),
    actionsWithTo: getActionsWithTo(connection.connector ? connection.connector.actions : []),
    derived: isDerived(connection)
  });
};

var useConnection = function useConnection(connectionId, initialValue) {
  return useApiResource({
    defaultValue: {
      name: ''
    },
    initialValue: initialValue,
    transformResponse: function transformResponse(response) {
      try {
        return Promise.resolve(response.json()).then(transformConnectionResponse);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    url: "/connections/" + connectionId
  });
};

var useConnector = function useConnector(connectorId, initialValue) {
  return useApiResource({
    defaultValue: {
      actions: [],
      name: ''
    },
    initialValue: initialValue,
    url: "/connectors/" + connectorId
  });
};

function objectWithoutProperties$3(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

var useConnectorVerifier = function useConnectorVerifier() {
  var ref = useApiResource({
    defaultValue: [],
    readOnMount: false,
    url: ''
  });
  var _read = ref.read;
  var rest$1 = objectWithoutProperties$3(ref, ["read"]);
  var rest = rest$1;
  return Object.assign({}, rest, {
    read: function read(connectorId, data) {
      return _read({
        body: data,
        method: 'POST',
        url: "/connectors/" + connectorId + "/verifier"
      });
    }
  });
};

var useConnectorCredentials = function useConnectorCredentials(connectorId) {
  return useApiResource({
    defaultValue: {},
    transformResponse: function transformResponse(response) {
      try {
        return Promise.resolve(response.json()).then(function (am) {
          return Object.keys(am).length > 0 ? am : undefined;
        });
      } catch (e) {
        return Promise.reject(e);
      }
    },
    url: "/connectors/" + connectorId + "/credentials"
  });
};

var useConnectorCredentialsConnect = function useConnectorCredentialsConnect(connectorId, returnUrl) {
  return useApiResource({
    body: {
      returnUrl: returnUrl
    },
    defaultValue: undefined,
    method: 'POST',
    readOnMount: true,
    url: "/connectors/" + connectorId + "/credentials"
  });
};

var useIntegrationHelpers = function useIntegrationHelpers() {
  var apiContext = React.useContext(ApiContext);

  var fetchStepDescriptors = function fetchStepDescriptors(steps) {
    try {
      return Promise.resolve(callFetch({
        body: steps,
        headers: apiContext.headers,
        method: 'POST',
        url: apiContext.apiUri + "/steps/descriptor"
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        return Promise.resolve(response.json());
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * adds a step of type connection to the provided integration object.
   *
   * @param integration - the integration object to modify
   * @param connection - the connection object that's been used to set up the
   * step
   * @param action - the action that's been used to set up the step
   * @param flowId - the zero-based index of the flow where to add the step
   * @param position - the zero-based index of the steps where to add the step
   * @param configuredProperties - the values configured by the user for the step
   *
   * @todo should we check `flow` and `position` to see if they are valid?
   * @todo perhaps rename it with a better name
   */


  var addConnection = function addConnection(integration, connection, action, flowId, position, configuredProperties) {
    try {
      return Promise.resolve(produce(integration, function () {
        try {
          return Promise.resolve(getActionDescriptor$$1(connection.id, action.id, configuredProperties)).then(function (actionDescriptor) {
            var step = setDescriptorOnStep({
              action: action,
              configuredProperties: configuredProperties,
              connection: connection,
              id: utils.key(),
              metadata: {
                configured: true
              },
              stepKind: 'endpoint'
            }, actionDescriptor);
            return insertStepIntoFlowBefore(integration, flowId, step, position, fetchStepDescriptors);
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * adds a step of type stepKind to the provided integration object.
   *
   * @param integration - the integration object to modify
   * @param stepKind - the action that's been used to set up the step
   * @param flowId - the zero-based index of the flow where to add the step
   * @param position - the zero-based index of the steps where to add the step
   * @param configuredProperties - the values configured by the user for the step
   *
   * @todo should we check `flow` and `position` to see if they are valid?
   * @todo perhaps rename it with a better name
   */


  var addStep = function addStep(integration, stepKind, flowId, position, configuredProperties) {
    try {
      return Promise.resolve(produce(integration, function () {
        try {
          var step = Object.assign({}, createStep(), stepKind, {
            configuredProperties: configuredProperties,
            metadata: {
              configured: true
            }
          });
          return Promise.resolve(insertStepIntoFlowBefore(integration, flowId, step, position, fetchStepDescriptors));
        } catch (e) {
          return Promise.reject(e);
        }
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Fetches the deployment of the given integration id at the given version
   * @param id
   * @param version
   */


  var getDeployment = function getDeployment(id, version) {
    try {
      return Promise.resolve(callFetch({
        headers: apiContext.headers,
        method: 'GET',
        url: apiContext.apiUri + "/integrations/" + id + "/deployments/" + version
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        return response.json();
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Patches an integration using the supplied attributes
   *
   * @param id
   * @param options
   */


  var setAttributes = function setAttributes(id, options) {
    try {
      return Promise.resolve(callFetch({
        body: options,
        headers: apiContext.headers,
        method: 'PATCH',
        url: apiContext.apiUri + "/integrations/" + id
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Replaces the current draft to the one at the specified version
   * @param id
   * @param version
   */


  var replaceDraft = function replaceDraft(id, version) {
    try {
      return Promise.resolve(getDeployment(id, version)).then(function (deployment) {
        return Promise.resolve(setAttributes(id, {
          flows: deployment.spec.flows
        })).then(function () {});
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Delete the integration with the specified ID, empty response is returned
   * @param id
   */


  var deleteIntegration = function deleteIntegration(id) {
    try {
      return Promise.resolve(callFetch({
        headers: apiContext.headers,
        method: 'DELETE',
        url: apiContext.apiUri + "/integrations/" + id
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Uploads and imports the supplied file as a new integration
   * @param file
   */


  var importIntegration = function importIntegration(file) {
    try {
      return Promise.resolve(callFetch({
        body: file,
        contentType: 'application/zip',
        headers: apiContext.headers,
        includeContentType: false,
        method: 'POST',
        url: apiContext.apiUri + "/integration-support/import"
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Uploads and imports the supplied OpenAPI specification
   */

  /**
   * Requests a .zip file of the integration, using the specified filename
   * @param id
   * @param fileName
   */


  var exportIntegration = function exportIntegration(id, fileName) {
    try {
      return Promise.resolve(callFetch({
        headers: apiContext.headers,
        method: 'GET',
        url: apiContext.apiUri + "/integration-support/export.zip?id=" + id
      }).then(function (body) {
        try {
          return Promise.resolve(body.blob()).then(function (_body$blob) {
            return fileSaver.saveAs(_body$blob, fileName);
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Fetches the descriptor for the specified action
   * @param connectionId
   * @param actionId
   * @param configuredProperties
   */


  var getActionDescriptor$$1 = function getActionDescriptor$$1(connectionId, actionId, configuredProperties) {
    try {
      return Promise.resolve(callFetch({
        body: configuredProperties || {},
        headers: apiContext.headers,
        method: 'POST',
        url: apiContext.apiUri + "/connections/" + connectionId + "/actions/" + actionId
      })).then(function (response) {
        function _temp4(_result) {
          return Promise.resolve(response.json());
        }

        var _temp3 = function () {
          if (!response.ok) {
            var _temp2 = function _temp2() {
              throw new Error(error);
            };

            var error = response.statusText;

            var _temp = _catch(function () {
              return Promise.resolve(response.json()).then(function (errResponse) {
                error = errResponse._meta.message;
              });
            }, function () {});

            return _temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp);
          }
        }();

        return _temp3 && _temp3.then ? _temp3.then(_temp4) : _temp4(_temp3);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Deploy the integration with the specified ID and version.  Empty response is returned
   *
   * @param id
   * @param version
   * @param isIntegrationDeployment
   */


  var deployIntegration = function deployIntegration(id, version, isIntegrationDeployment) {
    if (isIntegrationDeployment === void 0) isIntegrationDeployment = false;

    try {
      return Promise.resolve(callFetch({
        body: isIntegrationDeployment ? {
          targetState: PUBLISHED
        } : {},
        headers: apiContext.headers,
        method: isIntegrationDeployment ? 'POST' : 'PUT',
        url: isIntegrationDeployment ? apiContext.apiUri + "/integrations/" + id + "/deployments/" + version + "/targetState" : apiContext.apiUri + "/integrations/" + id + "/deployments"
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var downloadSupportData = function downloadSupportData(data) {
    try {
      return Promise.resolve(callFetch({
        body: data,
        headers: apiContext.headers,
        method: 'POST',
        url: apiContext.apiUri + "/support/downloadSupportZip"
      })).then(function (body) {
        return Promise.resolve(body.blob()).then(function (_body$blob2) {
          fileSaver.saveAs(_body$blob2, 'syndesis.zip');
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Request that the given integration ID at the given version be deactivated, empty response is returned
   * @param id
   * @param version
   */


  var undeployIntegration = function undeployIntegration(id, version) {
    try {
      return Promise.resolve(callFetch({
        body: {
          targetState: UNPUBLISHED
        },
        headers: apiContext.headers,
        method: 'POST',
        url: apiContext.apiUri + "/integrations/" + id + "/deployments/" + version + "/targetState"
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * updates a step of type connection to the provided integration object.
   *
   * @param integration - the integration object to modify
   * @param connection - the connection object that's been used to set up the
   * step
   * @param action - the action that's been used to set up the step
   * @param flowId - the zero-based index of the flow where to add the step
   * @param position - the zero-based index of the steps where to add the step
   * @param configuredProperties - the values configured by the user for the step
   *
   * @todo perhaps rename it with a better name
   * @todo should we check `flow` and `position` to see if they are valid?
   */


  var updateConnection = function updateConnection(integration, connection, action, flowId, position, configuredProperties) {
    try {
      return Promise.resolve(produce(integration, function () {
        try {
          return Promise.resolve(getActionDescriptor$$1(connection.id, action.id, configuredProperties)).then(function (actionDescriptor) {
            var step = setDescriptorOnStep({
              action: action,
              configuredProperties: configuredProperties,
              connection: connection,
              id: utils.key(),
              metadata: {
                configured: true
              },
              stepKind: 'endpoint'
            }, actionDescriptor);
            return setStepInFlow(integration, flowId, step, position, fetchStepDescriptors);
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * updates a step of type stepKind to the provided integration object.
   *
   * @param integration - the integration object to modify
   * @param stepKind - the action that's been used to set up the step
   * @param flowId - the zero-based index of the flow where to add the step
   * @param position - the zero-based index of the steps where to add the step
   * @param configuredProperties - the values configured by the user for the step
   *
   * @todo should we check `flow` and `position` to see if they are valid?
   * @todo perhaps rename it with a better name
   */


  var updateStep = function updateStep(integration, stepKind, flowId, position, configuredProperties) {
    try {
      return Promise.resolve(produce(integration, function () {
        try {
          var step = Object.assign({}, stepKind, {
            configuredProperties: configuredProperties,
            metadata: {
              configured: true
            }
          });
          return Promise.resolve(setStepInFlow(integration, flowId, step, position, fetchStepDescriptors));
        } catch (e) {
          return Promise.reject(e);
        }
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * asynchronously saves the provided integration, returning the saved
   * integration in case of success.
   *
   * @param integration
   *
   * @todo make the returned object immutable to avoid uncontrolled changes
   */


  var saveIntegration = function saveIntegration(integration) {
    try {
      return Promise.resolve(produce(integration, function () {
        try {
          var sanitizedIntegration = prepareIntegrationForSaving(integration);
          return Promise.resolve(callFetch({
            body: sanitizedIntegration,
            headers: apiContext.headers,
            method: sanitizedIntegration.id ? 'PUT' : 'POST',
            url: sanitizedIntegration.id ? apiContext.apiUri + "/integrations/" + sanitizedIntegration.id : apiContext.apiUri + "/integrations"
          })).then(function (response) {
            if (!response.ok) {
              throw new Error(response.statusText);
            }

            var _temp5 = !sanitizedIntegration.id;

            return _temp5 ? Promise.resolve(response.json()) : Promise.resolve(sanitizedIntegration);
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Tags the integration with the given CI/CD environments
   * @param integrationId
   * @param environments
   */


  var tagIntegration = function tagIntegration(integrationId, environments) {
    try {
      return Promise.resolve(callFetch({
        body: environments,
        headers: apiContext.headers,
        method: 'PUT',
        url: apiContext.apiUri + "/public/integrations/" + integrationId + "/tags"
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var removeStep = function removeStep(integration, flowId, position) {
    try {
      return Promise.resolve(produce(integration, function () {
        return removeStepFromFlow(integration, flowId, position, fetchStepDescriptors);
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return {
    addConnection: addConnection,
    addStep: addStep,
    deleteIntegration: deleteIntegration,
    deployIntegration: deployIntegration,
    downloadSupportData: downloadSupportData,
    exportIntegration: exportIntegration,
    getActionDescriptor: getActionDescriptor$$1,
    getDeployment: getDeployment,
    importIntegration: importIntegration,
    removeStep: removeStep,
    replaceDraft: replaceDraft,
    saveIntegration: saveIntegration,
    setAttributes: setAttributes,
    tagIntegration: tagIntegration,
    undeployIntegration: undeployIntegration,
    updateConnection: updateConnection,
    updateStep: updateStep
  };
};

var WithActionDescriptor =
/*@__PURE__*/
function (superclass) {
  function WithActionDescriptor() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithActionDescriptor.__proto__ = superclass;
  WithActionDescriptor.prototype = Object.create(superclass && superclass.prototype);
  WithActionDescriptor.prototype.constructor = WithActionDescriptor;

  WithActionDescriptor.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: "/connections/" + this.props.connectionId + "/actions/" + this.props.actionId,
      defaultValue: {},
      initialValue: this.props.initialValue,
      method: 'POST',
      body: this.props.configuredProperties || {}
    }, function (ref) {
      var response = ref.response;
      return this$1.props.children(response);
    });
  };

  return WithActionDescriptor;
}(React.Component);

var WithActivities =
/*@__PURE__*/
function (superclass) {
  function WithActivities() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithActivities.__proto__ = superclass;
  WithActivities.prototype = Object.create(superclass && superclass.prototype);
  WithActivities.prototype.constructor = WithActivities;

  WithActivities.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: "/integrations/" + this.props.integrationId + "/deployments",
      defaultValue: {
        items: [],
        totalCount: 0
      }
    }, function (ref) {
      var fetchDeployments = ref.read;
      var deployments = ref.response;
      return React.createElement(SyndesisFetch, {
        url: "/activity/integrations/" + this$1.props.integrationId,
        defaultValue: []
      }, function (ref) {
        var fetchActivities = ref.read;
        var activities = ref.response;
        return this$1.props.children({
          activities: activities.data,
          deployments: deployments.data.items,
          fetchActivities: fetchActivities,
          fetchDeployments: fetchDeployments
        });
      });
    });
  };

  return WithActivities;
}(React.Component);
/**
 * A component that fetches the API Connector with the specified identifier.
 * @see [apiConnectorId]{@link IWithApiConnectorProps#apiConnectorId}
 */


var WithApiConnector =
/*@__PURE__*/
function (superclass) {
  function WithApiConnector() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithApiConnector.__proto__ = superclass;
  WithApiConnector.prototype = Object.create(superclass && superclass.prototype);
  WithApiConnector.prototype.constructor = WithApiConnector;

  WithApiConnector.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: "/connectors/" + this.props.apiConnectorId,
      defaultValue: {
        actions: [],
        name: ''
      },
      initialValue: this.props.initialValue
    }, function (ref) {
      var response = ref.response;
      return this$1.props.children(response);
    });
  };

  return WithApiConnector;
}(React.Component);

function objectWithoutProperties$4(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

var WithApiConnectorHelpersWrapped =
/*@__PURE__*/
function (superclass) {
  function WithApiConnectorHelpersWrapped(props) {
    superclass.call(this, props);
    this.deleteApiConnector = this.deleteApiConnector.bind(this);
    this.saveApiConnector = this.saveApiConnector.bind(this);
    this.updateApiConnector = this.updateApiConnector.bind(this);
  }

  if (superclass) WithApiConnectorHelpersWrapped.__proto__ = superclass;
  WithApiConnectorHelpersWrapped.prototype = Object.create(superclass && superclass.prototype);
  WithApiConnectorHelpersWrapped.prototype.constructor = WithApiConnectorHelpersWrapped;
  /**
   * Deletes an API client connector.
   * @param apiConnectorId the ID of the API client connector being deleted
   */

  WithApiConnectorHelpersWrapped.prototype.deleteApiConnector = function deleteApiConnector(apiConnectorId) {
    try {
      var _this = this;

      return Promise.resolve(callFetch({
        headers: _this.props.headers,
        method: 'DELETE',
        url: _this.props.apiUri + "/connectors/" + apiConnectorId
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        return Promise.resolve();
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Saves an API client connector.
   * @param apiConnector the API client connector being saved
   * @returns the persisted connector
   */


  WithApiConnectorHelpersWrapped.prototype.saveApiConnector = function saveApiConnector(apiConnector) {
    try {
      var _this2 = this;

      return Promise.resolve(callFetch({
        body: apiConnector,
        headers: _this2.props.headers,
        method: apiConnector.id ? 'PUT' : 'POST',
        url: apiConnector.id ? _this2.props.apiUri + "/connectors/" + apiConnector.id : _this2.props.apiUri + "/connectors"
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        var _temp = !apiConnector.id;

        return _temp ? Promise.resolve(response.json()) : Promise.resolve(apiConnector);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  WithApiConnectorHelpersWrapped.prototype.updateApiConnector = function updateApiConnector(apiConnector, newName, newDescription, newHost, newBasePath, newIcon) {
    return produce(apiConnector, function (draft) {
      draft.name = newName;
      draft.description = newDescription;

      if (newIcon) {
        draft.icon = newIcon;
      }

      if (draft.configuredProperties) {
        if (newHost) {
          draft.configuredProperties.host = newHost;
        } else if (draft.configuredProperties.host) {
          var ref = draft.configuredProperties;
          var rest = objectWithoutProperties$4(ref, ["host"]);
          var noHost = rest;
          draft.configuredProperties = noHost;
        }

        if (newBasePath) {
          draft.configuredProperties.basePath = newBasePath;
        } else if (draft.configuredProperties.basePath) {
          var ref$1 = draft.configuredProperties;
          var rest = objectWithoutProperties$4(ref$1, ["basePath"]);
          var noBasePath = rest;
          draft.configuredProperties = noBasePath;
        }
      } else if (newHost || newBasePath) {
        if (newHost) {
          draft.configuredProperties = {
            host: newHost
          };
        }

        if (newBasePath) {
          if (draft.configuredProperties) {
            draft.configuredProperties.basePath = newBasePath;
          } else {
            draft.configuredProperties = {
              basePath: newBasePath
            };
          }
        }
      }
    });
  };

  WithApiConnectorHelpersWrapped.prototype.render = function render() {
    return this.props.children({
      deleteApiConnector: this.deleteApiConnector,
      saveApiConnector: this.saveApiConnector,
      updateApiConnector: this.updateApiConnector
    });
  };

  return WithApiConnectorHelpersWrapped;
}(React.Component);

var WithApiConnectorHelpers = function WithApiConnectorHelpers(props) {
  return React.createElement(ApiContext.Consumer, null, function (apiContext) {
    return React.createElement(WithApiConnectorHelpersWrapped, Object.assign({}, props, apiContext));
  });
};

var EVENT_SERVICE_CONNECTED = 'connected';
var RECONNECT_TIME = 5000;

var WithServerEvents =
/*@__PURE__*/
function (superclass) {
  function WithServerEvents(props) {
    superclass.call(this, props);
    this.starting = false;
    this.started = false;
    this.unmounting = false;
    this.retries = 0;
    this.preferredProtocol = '';
    this.changeListeners = [];
    this.messageListeners = [];
    this.registerChangeListener = this.registerChangeListener.bind(this);
    this.registerMessageListener = this.registerMessageListener.bind(this);
    this.unregisterChangeListener = this.unregisterChangeListener.bind(this);
    this.unregisterMessageListener = this.unregisterMessageListener.bind(this);
  }

  if (superclass) WithServerEvents.__proto__ = superclass;
  WithServerEvents.prototype = Object.create(superclass && superclass.prototype);
  WithServerEvents.prototype.constructor = WithServerEvents;

  WithServerEvents.prototype.registerChangeListener = function registerChangeListener(listener) {
    this.changeListeners = this.changeListeners.concat([listener]);
  };

  WithServerEvents.prototype.registerMessageListener = function registerMessageListener(listener) {
    this.messageListeners = this.messageListeners.concat([listener]);
  };

  WithServerEvents.prototype.unregisterChangeListener = function unregisterChangeListener(listener) {
    this.changeListeners = this.changeListeners.filter(function (l) {
      return l !== listener;
    });
  };

  WithServerEvents.prototype.unregisterMessageListener = function unregisterMessageListener(listener) {
    this.messageListeners = this.messageListeners.filter(function (l) {
      return l !== listener;
    });
  };

  WithServerEvents.prototype.componentDidMount = function componentDidMount() {
    try {
      var _this = this;

      _this.start();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  WithServerEvents.prototype.componentWillUnmount = function componentWillUnmount() {
    try {
      var _this2 = this;

      _this2.unmounting = true;

      _this2.close();

      _this2.changeListeners = [];
      _this2.messageListeners = [];
    } catch (e) {
      return Promise.reject(e);
    }
  };

  WithServerEvents.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState, nextContext) {
    return false;
  };

  WithServerEvents.prototype.render = function render() {
    return this.props.children({
      registerChangeListener: this.registerChangeListener,
      registerMessageListener: this.registerMessageListener,
      unregisterChangeListener: this.unregisterChangeListener,
      unregisterMessageListener: this.unregisterMessageListener
    });
  };

  WithServerEvents.prototype.close = function close() {
    this.started = false;
    this.starting = false;

    if (this.webSocket) {
      this.webSocket.close();
      this.webSocket = undefined;
    }

    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = undefined;
    }
  };

  WithServerEvents.prototype.start = function start() {
    this.startConnection(this.retries % 2 === 0);
  };

  WithServerEvents.prototype.onFailure = function onFailure(error) {
    var this$1 = this;
    this.close();

    if (this.unmounting) {
      return;
    }

    this.retries++; // Initialy retry very quickly.

    var reconnectIn = RECONNECT_TIME;

    if (this.retries < 3) {
      reconnectIn = 1;
    }

    setTimeout(function () {
      // console.log('Reconnecting');
      switch (this$1.preferredProtocol) {
        // Once we find a protocol that works, keep using it.
        case 'ws':
          this$1.startConnection(true);
          break;

        case 'es':
          this$1.startConnection(false);
          break;

        default:
          // Keep flipping between WS and ES untill we find one that works.
          this$1.startConnection(this$1.retries % 2 === 0);
          break;
      }
    }, reconnectIn);
  };

  WithServerEvents.prototype.startConnection = function startConnection(connectUsingWebSockets) {
    try {
      var _this3 = this;

      if (_this3.starting || _this3.started || _this3.unmounting) {
        return;
      }

      _this3.starting = true;

      var _temp = _catch(function () {
        return Promise.resolve(callFetch({
          body: '',
          headers: _this3.props.headers,
          method: 'POST',
          url: _this3.props.apiUri + "/event/reservations"
        })).then(function (response) {
          return Promise.resolve(response.json()).then(function (reservation) {
            reservation = reservation.data;

            if (connectUsingWebSockets) {
              var wsApiEndpoint = _this3.props.apiUri.replace(/^http/, 'ws');

              wsApiEndpoint += '/event/streams.ws/' + reservation; // console.log('Connecting using web socket');

              _this3.starting = false;
              _this3.started = true;

              _this3.connectWebSocket(wsApiEndpoint);
            } else {
              _this3.starting = false;
              _this3.started = true; // console.log('Connecting using server side events');

              _this3.connectEventSource(_this3.props.apiUri + '/event/streams/' + reservation);
            }
          });
        });
      }, function (error) {
        _this3.onFailure(error);
      });

      return _temp && _temp.then ? _temp.then(function () {}) : void 0;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  WithServerEvents.prototype.postMessageEvent = function postMessageEvent(messageEvent) {
    this.messageListeners.forEach(function (listener) {
      listener(messageEvent);
    });
  };

  WithServerEvents.prototype.postChangeEvent = function postChangeEvent(changeEvent) {
    this.changeListeners.forEach(function (listener) {
      listener(changeEvent);
    });
  };

  WithServerEvents.prototype.connectEventSource = function connectEventSource(url) {
    var this$1 = this;
    this.eventSource = new EventSource(url);
    this.eventSource.addEventListener('message', function (event) {
      this$1.started = true;
      this$1.starting = false;
      this$1.preferredProtocol = 'es'; // console.log('sse.message: ', event.data);

      this$1.postMessageEvent(event);
    });
    this.eventSource.addEventListener('change-event', function (event) {
      this$1.started = true;
      var value = JSON.parse(event.data); // console.log('sse.change-event: ', value);

      this$1.postChangeEvent(value);
    });

    var onError = function onError(event) {
      // console.log('sse.close: ', event);
      this$1.onFailure(event);
    };

    this.eventSource.addEventListener('close', onError);
    this.eventSource.addEventListener('error', onError);
    return this.eventSource;
  };

  WithServerEvents.prototype.connectWebSocket = function connectWebSocket(url) {
    var this$1 = this;
    this.webSocket = new WebSocket(url);

    this.webSocket.onmessage = function (event) {
      this$1.started = true;
      this$1.starting = false;
      var messageEvent = JSON.parse(event.data);

      switch (messageEvent.event) {
        case 'message':
          this$1.preferredProtocol = 'ws'; // console.log('ws.message: ', messageEvent.data);

          this$1.postMessageEvent(messageEvent);
          break;

        case 'change-event':
          var value = JSON.parse(messageEvent.data); // console.log('ws.change-event: ', value);

          this$1.postChangeEvent(value);
          break;

        default: // I guess we don't care what happens here...
        // console.log('ws.unknown-message: ', event);

      }
    };

    this.webSocket.onclose = function (event) {
      // console.log('ws.onclose: ', event);
      this$1.onFailure(event);
    };

    return this.webSocket;
  };

  return WithServerEvents;
}(React.Component);

var WithChangeListener =
/*@__PURE__*/
function (superclass) {
  function WithChangeListener(props) {
    superclass.call(this, props);
    this.changeListener = this.changeListener.bind(this);
    this.messageListener = this.messageListener.bind(this);
    this.read = this.read.bind(this);
    this.debouncedRead = this.props.disableDebounce ? this.read : utils.debounce(this.read, this.props.debounceWait || 250, false);
  }

  if (superclass) WithChangeListener.__proto__ = superclass;
  WithChangeListener.prototype = Object.create(superclass && superclass.prototype);
  WithChangeListener.prototype.constructor = WithChangeListener;

  WithChangeListener.prototype.read = function read() {
    this.props.read();
  };

  WithChangeListener.prototype.render = function render() {
    return this.props.children();
  };

  WithChangeListener.prototype.componentDidMount = function componentDidMount() {
    try {
      var _this = this;

      _this.props.registerChangeListener(_this.changeListener);

      _this.props.registerMessageListener(_this.messageListener);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  WithChangeListener.prototype.componentWillUnmount = function componentWillUnmount() {
    try {
      var _this2 = this;

      _this2.props.unregisterChangeListener(_this2.changeListener);

      _this2.props.unregisterMessageListener(_this2.messageListener);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  WithChangeListener.prototype.messageListener = function messageListener(event) {
    if (event.data === EVENT_SERVICE_CONNECTED) {
      this.debouncedRead();
    }
  };

  WithChangeListener.prototype.changeListener = function changeListener(event) {
    if (this.props.filter(event)) {
      this.debouncedRead();
    }
  };

  return WithChangeListener;
}(React.Component);

var WithApiConnectors =
/*@__PURE__*/
function (superclass) {
  function WithApiConnectors() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithApiConnectors.__proto__ = superclass;
  WithApiConnectors.prototype = Object.create(superclass && superclass.prototype);
  WithApiConnectors.prototype.constructor = WithApiConnectors;

  WithApiConnectors.prototype.changeFilter = function changeFilter(change) {
    return change.kind.startsWith('connector');
  };

  WithApiConnectors.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: '/connectors?query=connectorGroupId%3Dswagger-connector-template&per_page=50',
      defaultValue: {
        items: [],
        totalCount: 0
      }
    }, function (ref) {
      var read = ref.read;
      var response = ref.response;

      if (this$1.props.disableUpdates) {
        return this$1.props.children(response);
      }

      return React.createElement(ServerEventsContext.Consumer, null, function (ref) {
        var registerChangeListener = ref.registerChangeListener;
        var unregisterChangeListener = ref.unregisterChangeListener;
        var registerMessageListener = ref.registerMessageListener;
        var unregisterMessageListener = ref.unregisterMessageListener;
        return React.createElement(WithChangeListener, {
          read: read,
          registerChangeListener: registerChangeListener,
          unregisterChangeListener: unregisterChangeListener,
          registerMessageListener: registerMessageListener,
          unregisterMessageListener: unregisterMessageListener,
          filter: this$1.changeFilter
        }, function () {
          return this$1.props.children(response);
        });
      });
    });
  };

  return WithApiConnectors;
}(React.Component);

var WithApiVersion =
/*@__PURE__*/
function (superclass) {
  function WithApiVersion() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithApiVersion.__proto__ = superclass;
  WithApiVersion.prototype = Object.create(superclass && superclass.prototype);
  WithApiVersion.prototype.constructor = WithApiVersion;

  WithApiVersion.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: "/version",
      headers: {
        Accept: 'application/json'
      },
      defaultValue: {
        'build-id': '',
        camelkruntimeversion: '',
        camelversion: '',
        'commit-id': '',
        version: ''
      }
    }, function (ref) {
      var response = ref.response;
      return this$1.props.children(response);
    });
  };

  return WithApiVersion;
}(React.Component);

var WithConnection =
/*@__PURE__*/
function (superclass) {
  function WithConnection() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithConnection.__proto__ = superclass;
  WithConnection.prototype = Object.create(superclass && superclass.prototype);
  WithConnection.prototype.constructor = WithConnection;

  WithConnection.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: "/connections/" + this.props.id,
      defaultValue: {
        name: ''
      },
      initialValue: this.props.initialValue
    }, function (ref) {
      var response = ref.response;
      return this$1.props.children(Object.assign({}, response, {
        data: Object.assign({}, response.data, {
          actionsWithFrom: getActionsWithFrom(response.data.connector ? response.data.connector.actions : []),
          actionsWithTo: getActionsWithTo(response.data.connector ? response.data.connector.actions : [])
        })
      }));
    });
  };

  return WithConnection;
}(React.Component);

var WithConnectionHelpers = function WithConnectionHelpers(ref) {
  var children = ref.children;
  var helpers = useConnectionHelpers();
  return children(helpers);
};

function getConnectionsForDisplay(connections) {
  return connections.filter(function (c) {
    return !c.metadata || !c.metadata['hide-from-connection-pages'];
  });
}

function getConnectionsWithFromAction(connections) {
  return connections.filter(function (connection) {
    if (!connection.connector) {
      // safety net
      return true;
    }

    return connection.connector.actions.some(function (action) {
      return action.pattern === 'From';
    });
  });
}

function getConnectionsWithToAction(connections) {
  return connections.filter(function (connection) {
    if (!connection.connector) {
      // safety net
      return true;
    }

    if (connection.connectorId === 'api-provider') {
      // api provider can be used only for From actions
      return false;
    }

    return connection.connector.actions.some(function (action) {
      return action.pattern === 'To';
    });
  });
}

function transformResponse(response) {
  var connections = response.data.items.map(transformConnectionResponse);
  return Object.assign({}, response, {
    data: {
      connectionsForDisplay: getConnectionsForDisplay(connections),
      connectionsWithFromAction: getConnectionsWithFromAction(connections),
      connectionsWithToAction: getConnectionsWithToAction(connections),
      dangerouslyUnfilteredConnections: connections,
      totalCount: response.data.totalCount
    }
  });
}

var WithConnections =
/*@__PURE__*/
function (superclass) {
  function WithConnections() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithConnections.__proto__ = superclass;
  WithConnections.prototype = Object.create(superclass && superclass.prototype);
  WithConnections.prototype.constructor = WithConnections;

  WithConnections.prototype.changeFilter = function changeFilter(change) {
    return change.kind.startsWith('connection');
  };

  WithConnections.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: '/connections?per_page=50',
      defaultValue: {
        items: [],
        totalCount: 0
      }
    }, function (ref) {
      var read = ref.read;
      var response = ref.response;

      if (this$1.props.disableUpdates) {
        return this$1.props.children(transformResponse(response));
      }

      return React.createElement(ServerEventsContext.Consumer, null, function (ref) {
        var registerChangeListener = ref.registerChangeListener;
        var unregisterChangeListener = ref.unregisterChangeListener;
        var registerMessageListener = ref.registerMessageListener;
        var unregisterMessageListener = ref.unregisterMessageListener;
        return React.createElement(WithChangeListener, {
          read: read,
          registerChangeListener: registerChangeListener,
          unregisterChangeListener: unregisterChangeListener,
          registerMessageListener: registerMessageListener,
          unregisterMessageListener: unregisterMessageListener,
          debounceWait: this$1.props.debounceWait,
          filter: this$1.changeFilter
        }, function () {
          return this$1.props.children(transformResponse(response));
        });
      });
    });
  };

  return WithConnections;
}(React.Component);

var WithConnector =
/*@__PURE__*/
function (superclass) {
  function WithConnector() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithConnector.__proto__ = superclass;
  WithConnector.prototype = Object.create(superclass && superclass.prototype);
  WithConnector.prototype.constructor = WithConnector;

  WithConnector.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: "/connectors/" + this.props.id,
      defaultValue: {
        actions: [],
        name: ''
      },
      initialValue: this.props.initialValue
    }, function (ref) {
      var response = ref.response;
      return this$1.props.children(response);
    });
  };

  return WithConnector;
}(React.Component);

function getConnectorsForDisplay(connectors) {
  return connectors.filter(function (c) {
    return !c.metadata || !c.metadata['hide-from-connection-pages'];
  });
}

function transformConnectorsResponse(response) {
  return Object.assign({}, response, {
    data: {
      connectorsForDisplay: getConnectorsForDisplay(response.data.items),
      dangerouslyUnfilteredConnections: response.data.items,
      totalCount: response.data.totalCount
    }
  });
}

var WithConnectors =
/*@__PURE__*/
function (superclass) {
  function WithConnectors() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithConnectors.__proto__ = superclass;
  WithConnectors.prototype = Object.create(superclass && superclass.prototype);
  WithConnectors.prototype.constructor = WithConnectors;

  WithConnectors.prototype.changeFilter = function changeFilter(change) {
    return change.kind.startsWith('connector');
  };

  WithConnectors.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: '/connectors?per_page=50',
      defaultValue: {
        items: [],
        totalCount: 0
      }
    }, function (ref) {
      var read = ref.read;
      var response = ref.response;

      if (this$1.props.disableUpdates) {
        return this$1.props.children(transformConnectorsResponse(response));
      }

      return React.createElement(ServerEventsContext.Consumer, null, function (ref) {
        var registerChangeListener = ref.registerChangeListener;
        var unregisterChangeListener = ref.unregisterChangeListener;
        var registerMessageListener = ref.registerMessageListener;
        var unregisterMessageListener = ref.unregisterMessageListener;
        return React.createElement(WithChangeListener, {
          read: read,
          registerChangeListener: registerChangeListener,
          unregisterChangeListener: unregisterChangeListener,
          registerMessageListener: registerMessageListener,
          unregisterMessageListener: unregisterMessageListener,
          filter: this$1.changeFilter
        }, function () {
          return this$1.props.children(transformConnectorsResponse(response));
        });
      });
    });
  };

  return WithConnectors;
}(React.Component);

var WithEnvironmentHelpersWrapped =
/*@__PURE__*/
function (superclass) {
  function WithEnvironmentHelpersWrapped(props) {
    superclass.call(this, props);
    this.createEnvironment = this.createEnvironment.bind(this);
    this.deleteEnvironment = this.deleteEnvironment.bind(this);
    this.renameEnvironment = this.renameEnvironment.bind(this);
  }

  if (superclass) WithEnvironmentHelpersWrapped.__proto__ = superclass;
  WithEnvironmentHelpersWrapped.prototype = Object.create(superclass && superclass.prototype);
  WithEnvironmentHelpersWrapped.prototype.constructor = WithEnvironmentHelpersWrapped;

  WithEnvironmentHelpersWrapped.prototype.createEnvironment = function createEnvironment(name) {
    try {
      var _this = this;

      return Promise.resolve(callFetch({
        headers: _this.props.headers,
        method: 'POST',
        url: _this.props.apiUri + "/public/environments/" + name
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        return Promise.resolve(response.body);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  WithEnvironmentHelpersWrapped.prototype.deleteEnvironment = function deleteEnvironment(name) {
    try {
      var _this2 = this;

      return Promise.resolve(callFetch({
        headers: _this2.props.headers,
        method: 'DELETE',
        url: _this2.props.apiUri + "/public/environments/" + name
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        return Promise.resolve(response.body);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  WithEnvironmentHelpersWrapped.prototype.renameEnvironment = function renameEnvironment(name, newName) {
    try {
      var _this3 = this;

      return Promise.resolve(callFetch({
        body: newName,
        headers: _this3.props.headers,
        method: 'PUT',
        stringifyBody: false,
        url: _this3.props.apiUri + "/public/environments/" + name
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        return Promise.resolve(response.body);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  WithEnvironmentHelpersWrapped.prototype.render = function render() {
    return this.props.children({
      createEnvironment: this.createEnvironment,
      deleteEnvironment: this.deleteEnvironment,
      renameEnvironment: this.renameEnvironment
    });
  };

  return WithEnvironmentHelpersWrapped;
}(React.Component);

var WithEnvironmentHelpers = function WithEnvironmentHelpers(props) {
  return React.createElement(ApiContext.Consumer, null, function (apiContext) {
    return React.createElement(WithEnvironmentHelpersWrapped, Object.assign({}, props, apiContext));
  });
};

var WithPolling =
/*@__PURE__*/
function (superclass) {
  function WithPolling(props) {
    superclass.call(this, props);
    this.poller = this.poller.bind(this);
  }

  if (superclass) WithPolling.__proto__ = superclass;
  WithPolling.prototype = Object.create(superclass && superclass.prototype);
  WithPolling.prototype.constructor = WithPolling;

  WithPolling.prototype.componentDidMount = function componentDidMount() {
    try {
      var _this = this;

      _this.startPolling();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  WithPolling.prototype.componentWillUnmount = function componentWillUnmount() {
    try {
      var _this2 = this;

      _this2.stopPolling();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  WithPolling.prototype.render = function render() {
    return this.props.children();
  };

  WithPolling.prototype.poller = function poller() {
    this.props.read();
  };

  WithPolling.prototype.setPoller = function setPoller(func) {
    this.poller = func;
  };

  WithPolling.prototype.startPolling = function startPolling() {
    this.stopPolling();

    if (this.props.polling) {
      this.pollingTimer = setInterval(this.poller, this.props.polling);
    }
  };

  WithPolling.prototype.stopPolling = function stopPolling() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer);
      this.pollingTimer = undefined;
    }
  };

  return WithPolling;
}(React.Component);

var WithEnvironments =
/*@__PURE__*/
function (superclass) {
  function WithEnvironments() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithEnvironments.__proto__ = superclass;
  WithEnvironments.prototype = Object.create(superclass && superclass.prototype);
  WithEnvironments.prototype.constructor = WithEnvironments;

  WithEnvironments.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: '/public/environments',
      defaultValue: []
    }, function (ref) {
      var read = ref.read;
      var response = ref.response;

      if (this$1.props.disableUpdates) {
        return this$1.props.children(Object.assign({}, response, {
          read: read
        }));
      }

      return React.createElement(WithPolling, {
        read: read,
        polling: 5000
      }, function () {
        return this$1.props.children(Object.assign({}, response, {
          read: read
        }));
      });
    });
  };

  return WithEnvironments;
}(React.Component);
/**
 * A component that fetches the extension with the specified identifier.
 * @see [extensionId]{@link IWithExtensionProps#extensionId}
 */


var WithExtension =
/*@__PURE__*/
function (superclass) {
  function WithExtension() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithExtension.__proto__ = superclass;
  WithExtension.prototype = Object.create(superclass && superclass.prototype);
  WithExtension.prototype.constructor = WithExtension;

  WithExtension.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: "/extensions/" + this.props.extensionId,
      defaultValue: {
        actions: [],
        extensionType: 'Steps',
        name: '',
        schemaVersion: ''
      },
      initialValue: this.props.initialValue
    }, function (ref) {
      var response = ref.response;
      return this$1.props.children(response);
    });
  };

  return WithExtension;
}(React.Component);

function objectWithoutProperties$5(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

var WithExtensionHelpersWrapped =
/*@__PURE__*/
function (superclass) {
  function WithExtensionHelpersWrapped(props) {
    superclass.call(this, props);
    this.deleteExtension = this.deleteExtension.bind(this);
    this.importExtension = this.importExtension.bind(this);
    this.uploadExtension = this.uploadExtension.bind(this);
  }

  if (superclass) WithExtensionHelpersWrapped.__proto__ = superclass;
  WithExtensionHelpersWrapped.prototype = Object.create(superclass && superclass.prototype);
  WithExtensionHelpersWrapped.prototype.constructor = WithExtensionHelpersWrapped;
  /**
   * Deletes the extension with the specified identifier.
   * @param extensionId the ID of the extension being deleted
   */

  WithExtensionHelpersWrapped.prototype.deleteExtension = function deleteExtension(extensionId) {
    try {
      var _this = this;

      return Promise.resolve(callFetch({
        headers: _this.props.headers,
        method: 'DELETE',
        url: _this.props.apiUri + "/extensions/" + extensionId
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        return Promise.resolve();
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Imports the extension with the specified identifier.
   * @param extensionId the ID of the extension being imported
   */


  WithExtensionHelpersWrapped.prototype.importExtension = function importExtension(extensionId) {
    try {
      var _this2 = this;

      return Promise.resolve(callFetch({
        headers: _this2.props.headers,
        method: 'POST',
        url: _this2.props.apiUri + "/extensions/" + extensionId + "/install"
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        return Promise.resolve();
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Updates the extension with the specified identifier or creates a new extension if there is no identifier.
   * @param extensionId the ID of the extension being uploaded
   */


  WithExtensionHelpersWrapped.prototype.uploadExtension = function uploadExtension(file, extensionId) {
    try {
      var _this3 = this;

      var data = new FormData();
      data.append('file', file, file.name);
      var url = _this3.props.apiUri + "/extensions";
      var ref = _this3.props.headers;
      var rest$1 = objectWithoutProperties$5(ref, ["Accept", 'Content-Type']);
      var rest = rest$1;
      return Promise.resolve(callFetch({
        body: data,
        headers: Object.assign({}, rest),
        includeAccept: false,
        includeContentType: false,
        includeReferrerPolicy: false,
        method: 'POST',
        url: extensionId ? url + "?updatedId=" + extensionId : url
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        return Promise.resolve(response.json());
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  WithExtensionHelpersWrapped.prototype.render = function render() {
    return this.props.children({
      deleteExtension: this.deleteExtension,
      importExtension: this.importExtension,
      uploadExtension: this.uploadExtension
    });
  };

  return WithExtensionHelpersWrapped;
}(React.Component);

var WithExtensionHelpers = function WithExtensionHelpers(props) {
  return React.createElement(ApiContext.Consumer, null, function (apiContext) {
    return React.createElement(WithExtensionHelpersWrapped, Object.assign({}, props, apiContext));
  });
};
/**
 * A component that fetches the integrations that a specified extension is used by.
 * @see [extensionId]{@link IWithExtensionIntegrationsProps#extensionId}
 */


var WithExtensionIntegrations =
/*@__PURE__*/
function (superclass) {
  function WithExtensionIntegrations() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithExtensionIntegrations.__proto__ = superclass;
  WithExtensionIntegrations.prototype = Object.create(superclass && superclass.prototype);
  WithExtensionIntegrations.prototype.constructor = WithExtensionIntegrations;

  WithExtensionIntegrations.prototype.changeFilter = function changeFilter(change) {
    return (// rerun fetch if there was a change in integrations
      change.kind === 'integration' || change.kind === 'integration-deployment'
    );
  };

  WithExtensionIntegrations.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: "/extensions/" + this.props.extensionId + "/integrations",
      defaultValue: []
    }, function (ref) {
      var read = ref.read;
      var response = ref.response;
      return this$1.props.disableUpdates ? this$1.props.children(response) : React.createElement(ServerEventsContext.Consumer, null, function (ref) {
        var registerChangeListener = ref.registerChangeListener;
        var unregisterChangeListener = ref.unregisterChangeListener;
        var registerMessageListener = ref.registerMessageListener;
        var unregisterMessageListener = ref.unregisterMessageListener;
        return React.createElement(WithChangeListener, {
          read: read,
          registerChangeListener: registerChangeListener,
          unregisterChangeListener: unregisterChangeListener,
          registerMessageListener: registerMessageListener,
          unregisterMessageListener: unregisterMessageListener,
          filter: this$1.changeFilter
        }, function () {
          return this$1.props.children(response);
        });
      });
    });
  };

  return WithExtensionIntegrations;
}(React.Component);
/**
 * A component that fetches all the extensions.
 */


var WithExtensions =
/*@__PURE__*/
function (superclass) {
  function WithExtensions() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithExtensions.__proto__ = superclass;
  WithExtensions.prototype = Object.create(superclass && superclass.prototype);
  WithExtensions.prototype.constructor = WithExtensions;

  WithExtensions.prototype.changeFilter = function changeFilter(change) {
    return change.kind === 'extension';
  };

  WithExtensions.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: '/extensions?per_page=50',
      defaultValue: {
        items: [],
        totalCount: 0
      }
    }, function (ref) {
      var read = ref.read;
      var response = ref.response;
      return this$1.props.disableUpdates ? this$1.props.children(response) : React.createElement(ServerEventsContext.Consumer, null, function (ref) {
        var registerChangeListener = ref.registerChangeListener;
        var unregisterChangeListener = ref.unregisterChangeListener;
        var registerMessageListener = ref.registerMessageListener;
        var unregisterMessageListener = ref.unregisterMessageListener;
        return React.createElement(WithChangeListener, {
          read: read,
          registerChangeListener: registerChangeListener,
          unregisterChangeListener: unregisterChangeListener,
          registerMessageListener: registerMessageListener,
          unregisterMessageListener: unregisterMessageListener,
          filter: this$1.changeFilter
        }, function () {
          return this$1.props.children(response);
        });
      });
    });
  };

  return WithExtensions;
}(React.Component);

function getDefaultOps() {
  return [{
    label: 'equals',
    operator: '=='
  }, {
    label: 'equals (ignores case)',
    operator: '=~'
  }, {
    label: 'not equals',
    operator: '=='
  }, {
    operator: '<'
  }, {
    operator: '<='
  }, {
    operator: '>'
  }, {
    operator: '>='
  }, {
    label: 'contains',
    operator: 'contains'
  }, {
    label: 'contains (ignore case)',
    operator: '~~'
  }, {
    label: 'not contains',
    operator: 'not contains'
  }, {
    label: 'matches',
    operator: 'regex'
  }, {
    label: 'not matches',
    operator: 'not regex'
  }, {
    label: 'in',
    operator: 'in'
  }, {
    label: 'not in',
    operator: 'not in'
  }];
}

function convertOps(ops) {
  var answer = [];

  for (var i = 0, list = ops; i < list.length; i += 1) {
    // guard against blank label
    var op = list[i];
    var label = op.label || op.value || op.operator;
    var newOp = {
      label: label,
      value: op.value || op.operator
    };
    answer.push(newOp);
  }

  return answer;
}

var WithFilterOptions =
/*@__PURE__*/
function (superclass) {
  function WithFilterOptions() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithFilterOptions.__proto__ = superclass;
  WithFilterOptions.prototype = Object.create(superclass && superclass.prototype);
  WithFilterOptions.prototype.constructor = WithFilterOptions;

  WithFilterOptions.prototype.render = function render() {
    var this$1 = this;
    var defaultValue = {
      ops: [],
      paths: []
    };
    return React.createElement(SyndesisFetch, {
      body: this.props.dataShape,
      defaultValue: defaultValue,
      method: 'POST',
      url: "/integrations/filters/options"
    }, function (ref) {
      var response = ref.response;
      var ops = response.data.ops.length ? response.data.ops : getDefaultOps();
      var data = {
        ops: convertOps(ops),
        paths: response.data.paths || []
      };
      return this$1.props.children(Object.assign({}, response, {
        data: data
      }));
    });
  };

  return WithFilterOptions;
}(React.Component);
/**
 * A component that fetches the integration with the specified identifier.
 * @see [integrationId]{@link IWithIntegrationProps#integrationId}
 */


var WithIntegration =
/*@__PURE__*/
function (superclass) {
  function WithIntegration(props) {
    superclass.call(this, props);
    this.changeFilter = this.changeFilter.bind(this);
  }

  if (superclass) WithIntegration.__proto__ = superclass;
  WithIntegration.prototype = Object.create(superclass && superclass.prototype);
  WithIntegration.prototype.constructor = WithIntegration;

  WithIntegration.prototype.changeFilter = function changeFilter(change) {
    return change.kind.startsWith('integration') && change.id.startsWith(this.props.integrationId);
  };

  WithIntegration.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: "/integrations/" + this.props.integrationId,
      defaultValue: {
        isDraft: true,
        name: ''
      },
      initialValue: this.props.initialValue
    }, function (ref) {
      var read = ref.read;
      var response = ref.response;
      return this$1.props.disableUpdates ? this$1.props.children(response) : React.createElement(ServerEventsContext.Consumer, null, function (ref) {
        var registerChangeListener = ref.registerChangeListener;
        var unregisterChangeListener = ref.unregisterChangeListener;
        var registerMessageListener = ref.registerMessageListener;
        var unregisterMessageListener = ref.unregisterMessageListener;
        return React.createElement(WithChangeListener, {
          read: read,
          registerChangeListener: registerChangeListener,
          unregisterChangeListener: unregisterChangeListener,
          registerMessageListener: registerMessageListener,
          unregisterMessageListener: unregisterMessageListener,
          filter: this$1.changeFilter
        }, function () {
          return this$1.props.children(response);
        });
      });
    });
  };

  return WithIntegration;
}(React.Component);
/**
 * This component provides through a render prop a number of helper
 * functions useful when working with an integration.
 *
 * Some of these helpers are available also as stand-alone functions
 * (packages/api/src/integrationHelpers/index.ts), but this component provides
 * methods like `saveIntegration` that can talk with the backend without any
 * additional information provided.
 *
 * Methods that modify an integration return a immutable copy of the original
 * object, to reduce the risk of bugs.
 */


var WithIntegrationHelpers = function WithIntegrationHelpers(ref) {
  var children = ref.children;
  var helpers = useIntegrationHelpers();
  return children(helpers);
};

var WithIntegrationMetrics =
/*@__PURE__*/
function (superclass) {
  function WithIntegrationMetrics() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithIntegrationMetrics.__proto__ = superclass;
  WithIntegrationMetrics.prototype = Object.create(superclass && superclass.prototype);
  WithIntegrationMetrics.prototype.constructor = WithIntegrationMetrics;

  WithIntegrationMetrics.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: "/metrics/integrations/" + this.props.integrationId,
      defaultValue: {
        errors: 0,
        lastProcessed: "" + Date.now(),
        messages: 0,
        metricsProvider: 'null',
        start: "" + Date.now()
      }
    }, function (ref) {
      var read = ref.read;
      var response = ref.response;

      if (this$1.props.disableUpdates) {
        return this$1.props.children(response);
      }

      return React.createElement(WithPolling, {
        read: read,
        polling: 5000
      }, function () {
        return this$1.props.children(response);
      });
    });
  };

  return WithIntegrationMetrics;
}(React.Component);

var WithIntegrations =
/*@__PURE__*/
function (superclass) {
  function WithIntegrations() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithIntegrations.__proto__ = superclass;
  WithIntegrations.prototype = Object.create(superclass && superclass.prototype);
  WithIntegrations.prototype.constructor = WithIntegrations;

  WithIntegrations.prototype.changeFilter = function changeFilter(change) {
    return change.kind === 'integration' || change.kind === 'integration-deployment';
  };

  WithIntegrations.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: '/integrations?per_page=50',
      defaultValue: {
        items: [],
        totalCount: 0
      }
    }, function (ref) {
      var read = ref.read;
      var response = ref.response;
      return this$1.props.disableUpdates ? this$1.props.children(response) : React.createElement(ServerEventsContext.Consumer, null, function (ref) {
        var registerChangeListener = ref.registerChangeListener;
        var unregisterChangeListener = ref.unregisterChangeListener;
        var registerMessageListener = ref.registerMessageListener;
        var unregisterMessageListener = ref.unregisterMessageListener;
        return React.createElement(WithChangeListener, {
          read: read,
          registerChangeListener: registerChangeListener,
          unregisterChangeListener: unregisterChangeListener,
          registerMessageListener: registerMessageListener,
          unregisterMessageListener: unregisterMessageListener,
          filter: this$1.changeFilter
        }, function () {
          return this$1.props.children(response);
        });
      });
    });
  };

  return WithIntegrations;
}(React.Component);

var WithIntegrationsMetrics =
/*@__PURE__*/
function (superclass) {
  function WithIntegrationsMetrics() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithIntegrationsMetrics.__proto__ = superclass;
  WithIntegrationsMetrics.prototype = Object.create(superclass && superclass.prototype);
  WithIntegrationsMetrics.prototype.constructor = WithIntegrationsMetrics;

  WithIntegrationsMetrics.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: '/metrics/integrations',
      defaultValue: {
        errors: 0,
        id: '-1',
        integrationDeploymentMetrics: [],
        lastProcessed: "" + Date.now(),
        messages: 0,
        metricsProvider: 'null',
        start: "" + Date.now(),
        topIntegrations: {}
      }
    }, function (ref) {
      var read = ref.read;
      var response = ref.response;

      if (this$1.props.disableUpdates) {
        return this$1.props.children(response);
      }

      return React.createElement(WithPolling, {
        read: read,
        polling: 5000
      }, function () {
        return this$1.props.children(response);
      });
    });
  };

  return WithIntegrationsMetrics;
}(React.Component);

var WithIntegrationTags =
/*@__PURE__*/
function (superclass) {
  function WithIntegrationTags() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithIntegrationTags.__proto__ = superclass;
  WithIntegrationTags.prototype = Object.create(superclass && superclass.prototype);
  WithIntegrationTags.prototype.constructor = WithIntegrationTags;

  WithIntegrationTags.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: "/public/integrations/" + this.props.integrationId + "/tags",
      defaultValue: {},
      initialValue: this.props.initialValue
    }, function (ref) {
      var response = ref.response;
      return this$1.props.children(response);
    });
  };

  return WithIntegrationTags;
}(React.Component);

function objectWithoutProperties$6(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}
/**
 * A component that fetches the integration with the specified identifier.
 * @see [integrationId]{@link IWithIntegrationProps#integrationId}
 */


var WithMonitoredIntegration =
/*@__PURE__*/
function (superclass) {
  function WithMonitoredIntegration(props) {
    superclass.call(this, props);
    this.changeFilter = this.changeFilter.bind(this);
  }

  if (superclass) WithMonitoredIntegration.__proto__ = superclass;
  WithMonitoredIntegration.prototype = Object.create(superclass && superclass.prototype);
  WithMonitoredIntegration.prototype.constructor = WithMonitoredIntegration;

  WithMonitoredIntegration.prototype.changeFilter = function changeFilter(change) {
    return change.kind.startsWith('integration') && change.id.startsWith(this.props.integrationId);
  };

  WithMonitoredIntegration.prototype.getMonitoredIntegration = function getMonitoredIntegration(integration, response) {
    return {
      integration: integration,
      monitoring: response.data.find(function (o) {
        return o.integrationId === integration.id;
      })
    };
  };

  WithMonitoredIntegration.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(WithIntegration, {
      integrationId: this.props.integrationId,
      initialValue: this.props.initialValue,
      disableUpdates: this.props.disableUpdates
    }, function (ref) {
      var integration = ref.data;
      var rest = objectWithoutProperties$6(ref, ["data"]);
      var props = rest;
      return React.createElement(SyndesisFetch, {
        url: '/monitoring/integrations',
        defaultValue: []
      }, function (ref) {
        var read = ref.read;
        var response = ref.response;

        if (this$1.props.disableUpdates) {
          var data = this$1.getMonitoredIntegration(integration, response);
          return this$1.props.children(Object.assign({}, props, {
            data: data
          }));
        }

        return React.createElement(ServerEventsContext.Consumer, null, function (ref) {
          var registerChangeListener = ref.registerChangeListener;
          var unregisterChangeListener = ref.unregisterChangeListener;
          var registerMessageListener = ref.registerMessageListener;
          var unregisterMessageListener = ref.unregisterMessageListener;
          return React.createElement(WithChangeListener, {
            read: read,
            registerChangeListener: registerChangeListener,
            unregisterChangeListener: unregisterChangeListener,
            registerMessageListener: registerMessageListener,
            unregisterMessageListener: unregisterMessageListener,
            filter: this$1.changeFilter
          }, function () {
            var data = this$1.getMonitoredIntegration(integration, response);
            return this$1.props.children(Object.assign({}, props, {
              data: data
            }));
          });
        });
      });
    });
  };

  return WithMonitoredIntegration;
}(React.Component);

function objectWithoutProperties$7(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

var WithMonitoredIntegrations =
/*@__PURE__*/
function (superclass) {
  function WithMonitoredIntegrations() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithMonitoredIntegrations.__proto__ = superclass;
  WithMonitoredIntegrations.prototype = Object.create(superclass && superclass.prototype);
  WithMonitoredIntegrations.prototype.constructor = WithMonitoredIntegrations;

  WithMonitoredIntegrations.prototype.changeFilter = function changeFilter(change) {
    return change.kind === 'integration-deployment' || change.kind === 'integration-deployment-state-details';
  };

  WithMonitoredIntegrations.prototype.getMonitoredIntegrations = function getMonitoredIntegrations(integrations, response) {
    return {
      items: integrations.items.map(function (i) {
        return {
          integration: i,
          monitoring: response.data.find(function (o) {
            return o.integrationId === i.id;
          })
        };
      }),
      totalCount: integrations.totalCount
    };
  };

  WithMonitoredIntegrations.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(WithIntegrations, {
      disableUpdates: this.props.disableUpdates
    }, function (ref) {
      var integrations = ref.data;
      var rest = objectWithoutProperties$7(ref, ["data"]);
      var props = rest;
      return React.createElement(SyndesisFetch, {
        url: '/monitoring/integrations',
        defaultValue: []
      }, function (ref) {
        var read = ref.read;
        var response = ref.response;

        if (this$1.props.disableUpdates) {
          var data = this$1.getMonitoredIntegrations(integrations, response);
          return this$1.props.children(Object.assign({}, props, {
            data: data
          }));
        }

        return React.createElement(ServerEventsContext.Consumer, null, function (ref) {
          var registerChangeListener = ref.registerChangeListener;
          var unregisterChangeListener = ref.unregisterChangeListener;
          var registerMessageListener = ref.registerMessageListener;
          var unregisterMessageListener = ref.unregisterMessageListener;
          return React.createElement(WithChangeListener, {
            read: read,
            registerChangeListener: registerChangeListener,
            unregisterChangeListener: unregisterChangeListener,
            registerMessageListener: registerMessageListener,
            unregisterMessageListener: unregisterMessageListener,
            filter: this$1.changeFilter
          }, function () {
            var data = this$1.getMonitoredIntegrations(integrations, response);
            return this$1.props.children(Object.assign({}, props, {
              data: data
            }));
          });
        });
      });
    });
  };

  return WithMonitoredIntegrations;
}(React.Component);

var WithOAuthAppHelpersWrapped =
/*@__PURE__*/
function (superclass) {
  function WithOAuthAppHelpersWrapped(props) {
    superclass.call(this, props);
    this.updateOAuthApp = this.updateOAuthApp.bind(this);
    this.deleteOAuthApp = this.deleteOAuthApp.bind(this);
  }

  if (superclass) WithOAuthAppHelpersWrapped.__proto__ = superclass;
  WithOAuthAppHelpersWrapped.prototype = Object.create(superclass && superclass.prototype);
  WithOAuthAppHelpersWrapped.prototype.constructor = WithOAuthAppHelpersWrapped;

  WithOAuthAppHelpersWrapped.prototype.updateOAuthApp = function updateOAuthApp(app) {
    try {
      var _this = this;

      return Promise.resolve(callFetch({
        body: app,
        headers: _this.props.headers,
        method: 'PUT',
        url: _this.props.apiUri + "/setup/oauth-apps/" + app.id
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  WithOAuthAppHelpersWrapped.prototype.deleteOAuthApp = function deleteOAuthApp(id) {
    try {
      var _this2 = this;

      return Promise.resolve(callFetch({
        headers: _this2.props.headers,
        method: 'DELETE',
        url: _this2.props.apiUri + "/setup/oauth-apps/" + id
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  WithOAuthAppHelpersWrapped.prototype.render = function render() {
    return this.props.children({
      deleteOAuthApp: this.deleteOAuthApp,
      updateOAuthApp: this.updateOAuthApp
    });
  };

  return WithOAuthAppHelpersWrapped;
}(React.Component);

var WithOAuthAppHelpers = function WithOAuthAppHelpers(props) {
  return React.createElement(ApiContext.Consumer, null, function (apiContext) {
    return React.createElement(WithOAuthAppHelpersWrapped, Object.assign({}, props, apiContext));
  });
};

var WithOAuthApps =
/*@__PURE__*/
function (superclass) {
  function WithOAuthApps() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithOAuthApps.__proto__ = superclass;
  WithOAuthApps.prototype = Object.create(superclass && superclass.prototype);
  WithOAuthApps.prototype.constructor = WithOAuthApps;

  WithOAuthApps.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: '/setup/oauth-apps?per_page=50',
      defaultValue: {
        items: [],
        totalCount: 0
      }
    }, function (ref) {
      var read = ref.read;
      var response = ref.response;

      if (this$1.props.disableUpdates) {
        return this$1.props.children(Object.assign({}, response, {
          read: read
        }));
      }

      return React.createElement(WithPolling, {
        read: read,
        polling: 5000
      }, function () {
        return this$1.props.children(Object.assign({}, response, {
          read: read
        }));
      });
    });
  };

  return WithOAuthApps;
}(React.Component);

var ALL_STEPS = [requiresInputDataShape({
  name: 'Data Mapper',
  description: 'Map fields from the input type to the output type.',
  stepKind: DATA_MAPPER,
  properties: {},
  configuredProperties: undefined,
  visible: []
}), requiresOutputDataShape({
  name: 'Basic Filter',
  description: 'Continue the integration only if criteria you specify in simple input fields are met. Suitable for' + ' most integrations.',
  stepKind: BASIC_FILTER,
  properties: undefined,
  configuredProperties: undefined,
  visible: []
}, true), requiresOutputDataShape({
  name: 'Template',
  stepKind: TEMPLATE,
  description: 'Upload or create a Freemarker, Mustache or Velocity template to define consistent output data.',
  configuredProperties: undefined,
  properties: undefined,
  visible: []
}), noCollectionSupport({
  name: 'Advanced Filter',
  description: 'Continue the integration only if criteria you define in scripting language expressions are met.',
  stepKind: ADVANCED_FILTER,
  properties: {
    filter: {
      type: 'textarea',
      displayName: 'Only continue if',
      placeholder: "Examples of Simple Language filter expressions:\n${in.header.type} == 'widget' // Evaluates true when type = widget\n${in.body.title} // Evaluates true when body contains title.\n",
      required: true,
      rows: 10
    }
  },
  configuredProperties: undefined,
  visible: []
}), {
  name: 'Log',
  stepKind: LOG,
  description: "Send a message to the integration's log.",
  configuredProperties: undefined,
  properties: {
    contextLoggingEnabled: {
      type: 'boolean',
      displayName: 'Message Context',
      required: false
    },
    bodyLoggingEnabled: {
      type: 'boolean',
      displayName: 'Message Body',
      required: false
    },
    customText: {
      type: 'string',
      displayName: 'Custom Text',
      required: false
    }
  },
  visible: []
}, notAllowedInSubFlow(requiresOutputDataShape({
  action: {
    actionType: 'step',
    descriptor: {
      inputDataShape: noShape(),
      outputDataShape: anyShape()
    }
  },
  name: 'Conditional Flows',
  description: 'Sends the message to different flows based on condition evaluation',
  stepKind: CHOICE,
  properties: {},
  configuredProperties: undefined,
  visible: []
}, true)), requiresOutputDataShape({
  id: undefined,
  connection: undefined,
  action: undefined,
  name: 'Split',
  description: 'Process each item in a set of data individually',
  stepKind: SPLIT,
  properties: {},
  configuredProperties: undefined,
  visible: []
}), requiresConsistentSplitAggregate({
  id: undefined,
  connection: undefined,
  action: undefined,
  name: 'Aggregate',
  description: 'End processing items in a foreach',
  stepKind: AGGREGATE,
  properties: {},
  configuredProperties: undefined,
  visible: []
})];

function stepsHaveOutputDataShape(steps) {
  return steps.filter(function (s) {
    return s && s.action && s.action.descriptor && s.action.descriptor.outputDataShape && s.action.descriptor.outputDataShape.kind && toDataShapeKinds(s.action.descriptor.outputDataShape.kind) !== exports.DataShapeKinds.NONE && toDataShapeKinds(s.action.descriptor.outputDataShape.kind) !== exports.DataShapeKinds.ANY;
  }).length > 0;
}

function stepsHaveInputDataShape(steps) {
  return steps.filter(function (s) {
    return s && s.action && s.action.descriptor && s.action.descriptor.inputDataShape && s.action.descriptor.inputDataShape.kind && toDataShapeKinds(s.action.descriptor.inputDataShape.kind) !== exports.DataShapeKinds.NONE && toDataShapeKinds(s.action.descriptor.inputDataShape.kind) !== exports.DataShapeKinds.ANY;
  }).length > 0;
}

function notAllowedInSubFlow(obj) {
  obj.visible.push(function (position, previousSteps, subsequentSteps) {
    return previousSteps.find(function (s) {
      return typeof s.connection !== 'undefined' && typeof s.connection.connectorId !== 'undefined' && s.connection.connectorId === FLOW;
    }) === undefined && subsequentSteps.find(function (s) {
      return typeof s.connection !== 'undefined' && typeof s.connection.connectorId !== undefined && s.connection.connectorId === FLOW;
    }) === undefined;
  });
  return obj;
} // currently no steps fit this criteria but that could change


function dataShapeExists(step, input) {
  if (input === void 0) input = false;

  if (input) {
    return !!(step && step.action && step.action.descriptor && step.action.descriptor.inputDataShape);
  } else {
    return !!(step && step.action && step.action.descriptor && step.action.descriptor.outputDataShape);
  }
}

function hasPrecedingCollection(previousSteps) {
  var previousDataShape = previousSteps.reduceRight(function (foundStep, s) {
    return !foundStep && dataShapeExists(s) ? s : foundStep;
  }, undefined);
  return previousDataShape && previousDataShape.action && previousDataShape.action.descriptor && previousDataShape.action.descriptor.outputDataShape && previousDataShape.action.descriptor.outputDataShape.metadata && previousDataShape.action.descriptor.outputDataShape.metadata.variant === 'collection';
}

function noCollectionSupport(obj) {
  obj.visible.push(function (position, previousSteps, subsequentSteps) {
    return !hasPrecedingCollection(previousSteps);
  });
  return obj;
}

function requiresOutputDataShape(obj, noCollectionSupportP) {
  if (noCollectionSupportP === void 0) noCollectionSupportP = false;

  if (noCollectionSupportP) {
    obj.visible.push(function (position, previousSteps, subsequentSteps) {
      return stepsHaveOutputDataShape(previousSteps) && !hasPrecedingCollection(previousSteps);
    });
  } else {
    obj.visible.push(function (position, previousSteps, subsequentSteps) {
      return stepsHaveOutputDataShape(previousSteps);
    });
  }

  return obj;
}

function requiresInputDataShape(obj, noCollectionSupportP) {
  if (noCollectionSupportP === void 0) noCollectionSupportP = false;

  if (noCollectionSupportP) {
    obj.visible.push(function (position, previousSteps, subsequentSteps) {
      return stepsHaveInputDataShape(subsequentSteps) && !hasPrecedingCollection(previousSteps);
    });
  } else {
    obj.visible.push(function (position, previousSteps, subsequentSteps) {
      return stepsHaveInputDataShape(subsequentSteps);
    });
  }

  return obj;
}

function requiresConsistentSplitAggregate(obj) {
  obj.visible.push(function (position, previousSteps, subsequentSteps) {
    var countPreviousSplit = previousSteps.filter(function (s) {
      return s.stepKind === SPLIT;
    }).length;
    var countPreviousAggregate = previousSteps.filter(function (s) {
      return (s.stepKind || '').toLowerCase() === AGGREGATE;
    }).length;

    if (countPreviousSplit <= countPreviousAggregate) {
      return false;
    }

    var positionNextSplit = subsequentSteps.findIndex(function (s) {
      return s.stepKind === SPLIT;
    });
    var positionNextAggregate = subsequentSteps.findIndex(function (s) {
      return s.stepKind === AGGREGATE;
    });

    if (positionNextSplit === -1) {
      return positionNextAggregate === -1;
    }

    return positionNextAggregate === -1 || positionNextSplit < positionNextAggregate;
  });
  return obj;
}

function anyShape() {
  return {
    kind: toDataShapeKindType(exports.DataShapeKinds.ANY),
    name: 'Any shape'
  };
}

function noShape() {
  return {
    kind: toDataShapeKindType(exports.DataShapeKinds.NONE),
    name: 'No shape'
  };
}

var WithSteps = function WithSteps(ref) {
  var children = ref.children;
  return children({
    items: ALL_STEPS
  });
};

var WithUser =
/*@__PURE__*/
function (superclass) {
  function WithUser() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithUser.__proto__ = superclass;
  WithUser.prototype = Object.create(superclass && superclass.prototype);
  WithUser.prototype.constructor = WithUser;

  WithUser.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(SyndesisFetch, {
      url: '/users/~',
      defaultValue: {
        username: 'nobody'
      }
    }, function (ref) {
      var response = ref.response;
      return this$1.props.children(Object.assign({}, response));
    });
  };

  return WithUser;
}(React.Component);

var WithUserHelpersWrapped =
/*@__PURE__*/
function (superclass) {
  function WithUserHelpersWrapped(props) {
    superclass.call(this, props);
    this.logout = this.logout.bind(this);
  }

  if (superclass) WithUserHelpersWrapped.__proto__ = superclass;
  WithUserHelpersWrapped.prototype = Object.create(superclass && superclass.prototype);
  WithUserHelpersWrapped.prototype.constructor = WithUserHelpersWrapped;

  WithUserHelpersWrapped.prototype.logout = function logout() {
    try {
      var _this = this;

      return Promise.resolve(callFetch({
        headers: Object.assign({}, _this.props.headers, {
          responseType: 'arraybuffer'
        }),
        method: 'GET',
        url: '/logout'
      })).then(function (response) {
        return Promise.resolve(response.arrayBuffer());
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  WithUserHelpersWrapped.prototype.render = function render() {
    return this.props.children({
      logout: this.logout
    });
  };

  return WithUserHelpersWrapped;
}(React.Component);

var WithUserHelpers = function WithUserHelpers(props) {
  return React.createElement(ApiContext.Consumer, null, function (apiContext) {
    return React.createElement(WithUserHelpersWrapped, Object.assign({}, props, apiContext));
  });
};
/**
 * A component that fetches the specified VDB model
 * @see [vdbId]{@link IWithVdbModelProps#vdbId}
 * @see [modelId]{@link IWithVdbModelProps#modelId}
 */


var WithVdbModel =
/*@__PURE__*/
function (superclass) {
  function WithVdbModel() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithVdbModel.__proto__ = superclass;
  WithVdbModel.prototype = Object.create(superclass && superclass.prototype);
  WithVdbModel.prototype.constructor = WithVdbModel;

  WithVdbModel.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(DVFetch, {
      url: "workspace/vdbs/" + this.props.vdbId + "/Models/" + this.props.modelId,
      defaultValue: {
        keng__baseUri: '',
        keng__dataPath: '',
        keng__ddl: '',
        keng__hasChildren: false,
        keng__id: '',
        keng__kType: '',
        mmcore__modelType: '',
        vdb__metadataType: 'DDL',
        vdb__visible: false
      }
    }, function (ref) {
      var response = ref.response;
      return this$1.props.children(Object.assign({}, response));
    });
  };

  return WithVdbModel;
}(React.Component);

var WithViewEditorStates =
/*@__PURE__*/
function (superclass) {
  function WithViewEditorStates() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithViewEditorStates.__proto__ = superclass;
  WithViewEditorStates.prototype = Object.create(superclass && superclass.prototype);
  WithViewEditorStates.prototype.constructor = WithViewEditorStates;

  WithViewEditorStates.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(DVFetch, {
      url: 'service/userProfile/viewEditorState' + (this.props.idPattern ? '?pattern=' + this.props.idPattern : ''),
      defaultValue: []
    }, function (ref) {
      var read = ref.read;
      var response = ref.response;
      return this$1.props.children(Object.assign({}, response, {
        read: read
      }));
    });
  };

  return WithViewEditorStates;
}(React.Component);
/**
 * A component that fetches the specified VDB views.
 * @see [vdbId]{@link IWithViewProps#vdbId}
 */


var WithViews =
/*@__PURE__*/
function (superclass) {
  function WithViews() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithViews.__proto__ = superclass;
  WithViews.prototype = Object.create(superclass && superclass.prototype);
  WithViews.prototype.constructor = WithViews;

  WithViews.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(DVFetch, {
      url: "workspace/vdbs/" + this.props.vdbId + "/Models/views/Views",
      defaultValue: [],
      initialValue: this.props.initialValue
    }, function (ref) {
      var response = ref.response;
      return this$1.props.children(response);
    });
  };

  return WithViews;
}(React.Component);
/**
 * A component that fetches the virtualization with the specified identifier.
 * @see [virtualizationId]{@link IWithVirtualizationProps#virtualizationId}
 */


var WithVirtualization =
/*@__PURE__*/
function (superclass) {
  function WithVirtualization() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithVirtualization.__proto__ = superclass;
  WithVirtualization.prototype = Object.create(superclass && superclass.prototype);
  WithVirtualization.prototype.constructor = WithVirtualization;

  WithVirtualization.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(DVFetch, {
      url: "workspace/dataservices/" + this.props.virtualizationId,
      defaultValue: {
        connections: 0,
        drivers: 0,
        keng___links: [],
        keng__baseUri: '',
        keng__dataPath: '',
        keng__hasChildren: false,
        keng__id: '',
        keng__kType: '',
        publishedState: 'NOTFOUND',
        serviceVdbName: '',
        serviceVdbVersion: '',
        serviceViewDefinitions: [],
        serviceViewModel: '',
        tko__description: ''
      },
      initialValue: this.props.initialValue
    }, function (ref) {
      var response = ref.response;
      return this$1.props.children(response);
    });
  };

  return WithVirtualization;
}(React.Component);

var WithVirtualizationConnectionSchema =
/*@__PURE__*/
function (superclass) {
  function WithVirtualizationConnectionSchema() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithVirtualizationConnectionSchema.__proto__ = superclass;
  WithVirtualizationConnectionSchema.prototype = Object.create(superclass && superclass.prototype);
  WithVirtualizationConnectionSchema.prototype.constructor = WithVirtualizationConnectionSchema;

  WithVirtualizationConnectionSchema.prototype.render = function render() {
    var this$1 = this;
    var restUrl = this.props.connectionId ? "metadata/" + this.props.connectionId + "/schema" : "metadata/connection-schema";
    return React.createElement(DVFetch, {
      url: restUrl,
      defaultValue: []
    }, function (ref) {
      var response = ref.response;
      return this$1.props.children(response);
    });
  };

  return WithVirtualizationConnectionSchema;
}(React.Component);

var WithVirtualizationConnectionStatuses =
/*@__PURE__*/
function (superclass) {
  function WithVirtualizationConnectionStatuses() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithVirtualizationConnectionStatuses.__proto__ = superclass;
  WithVirtualizationConnectionStatuses.prototype = Object.create(superclass && superclass.prototype);
  WithVirtualizationConnectionStatuses.prototype.constructor = WithVirtualizationConnectionStatuses;

  WithVirtualizationConnectionStatuses.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(DVFetch, {
      url: 'metadata/syndesisSourceStatuses',
      defaultValue: []
    }, function (ref) {
      var response = ref.response;
      return this$1.props.children(response);
    });
  };

  return WithVirtualizationConnectionStatuses;
}(React.Component);

var WORKSPACE_ROOT = '/tko:komodo/tko:workspace/';

var WithVirtualizationHelpersWrapped =
/*@__PURE__*/
function (superclass) {
  function WithVirtualizationHelpersWrapped(props) {
    superclass.call(this, props);
    this.createVirtualization = this.createVirtualization.bind(this);
    this.updateViewEditorStates = this.updateViewEditorStates.bind(this);
    this.deleteView = this.deleteView.bind(this);
    this.deleteViewEditorState = this.deleteViewEditorState.bind(this);
    this.deleteVirtualization = this.deleteVirtualization.bind(this);
    this.publishVirtualization = this.publishVirtualization.bind(this);
    this.queryVirtualization = this.queryVirtualization.bind(this);
    this.refreshVirtualizationViews = this.refreshVirtualizationViews.bind(this);
    this.unpublishServiceVdb = this.unpublishServiceVdb.bind(this);
    this.validateViewDefinition = this.validateViewDefinition.bind(this);
    this.validateVirtualizationName = this.validateVirtualizationName.bind(this);
    this.validateViewName = this.validateViewName.bind(this);
  }

  if (superclass) WithVirtualizationHelpersWrapped.__proto__ = superclass;
  WithVirtualizationHelpersWrapped.prototype = Object.create(superclass && superclass.prototype);
  WithVirtualizationHelpersWrapped.prototype.constructor = WithVirtualizationHelpersWrapped;
  /**
   * Creates a virtualization with the specified name and description
   * @param username the username (used to define the workspace path)
   * @param virtName the name of the virtualization to create
   * @param virtDesc the description (optional) of the virtualization to create
   */

  WithVirtualizationHelpersWrapped.prototype.createVirtualization = function createVirtualization(username, virtName, virtDesc) {
    try {
      var _this = this;

      var newVirtualization = {
        keng__dataPath: "" + WORKSPACE_ROOT + username + "/" + virtName,
        keng__id: "" + virtName,
        serviceVdbName: ("" + virtName).toLowerCase() + 'vdb',
        tko__description: virtDesc ? "" + virtDesc : ''
      };
      return Promise.resolve(callFetch({
        body: newVirtualization,
        headers: {},
        method: 'POST',
        url: _this.props.dvApiUri + "workspace/dataservices/" + virtName
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        return Promise.resolve(newVirtualization);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Deletes the specified virtualization view.
   * @param virtualization the virtualization
   * @param viewName the name of the view being deleted
   */


  WithVirtualizationHelpersWrapped.prototype.deleteView = function deleteView(virtualization, viewName) {
    try {
      var _this2 = this;

      var vdbName = virtualization.serviceVdbName;
      var editorStateId = vdbName + '.' + viewName; // Delete viewEditorState

      return Promise.resolve(_this2.deleteViewEditorState(editorStateId)).then(function () {
        // Delete virtualization view
        return Promise.resolve(callFetch({
          headers: {},
          method: 'DELETE',
          url: _this2.props.dvApiUri + "workspace/vdbs/" + vdbName + "/Models/views/Views/" + viewName
        })).then(function (response) {
          if (!response.ok) {
            throw new Error(response.statusText);
          }

          return Promise.resolve();
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Deletes the virtualization with the specified name.
   * @param virtualizationName the name of the virtualization being deleted
   */


  WithVirtualizationHelpersWrapped.prototype.deleteVirtualization = function deleteVirtualization(virtualizationName) {
    try {
      var _this3 = this;

      return Promise.resolve(callFetch({
        headers: {},
        method: 'DELETE',
        url: _this3.props.dvApiUri + "workspace/dataservices/" + virtualizationName
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        return Promise.resolve();
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Publish the virtualization with the specified name.
   * @param virtualizationName the name of the virtualization being published
   */


  WithVirtualizationHelpersWrapped.prototype.publishVirtualization = function publishVirtualization(virtualizationName) {
    try {
      var _this4 = this;

      var pubVirtualization = {
        name: "" + virtualizationName
      };
      return Promise.resolve(callFetch({
        body: pubVirtualization,
        headers: {},
        method: 'POST',
        url: _this4.props.dvApiUri + "metadata/publish"
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        return Promise.resolve();
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Query the Service VDB with sql query and properties.
   * @param virtualizationName the name of the virtualization associated with the service
   * @param sqlQuery the sql query statement to execute against the virtualization
   * @param rowlimit limit to number of rows to return
   * @param rowOffset number of data rows to filter from the beginning of the result set
   */


  WithVirtualizationHelpersWrapped.prototype.queryVirtualization = function queryVirtualization(virtualizationName, sqlQuery, rowlimit, rowOffset) {
    try {
      var _this5 = this; // The payload for the rest call


      var queryBody = {
        limit: rowlimit,
        offset: rowOffset,
        query: sqlQuery,
        target: virtualizationName
      };
      return Promise.resolve(callFetch({
        body: queryBody,
        headers: {},
        method: 'POST',
        url: _this5.props.dvApiUri + "metadata/query"
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        return Promise.resolve(response.json());
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Validate the supplied ViewDefinition
   * @param viewDefinition the view definition
   */


  WithVirtualizationHelpersWrapped.prototype.validateViewDefinition = function validateViewDefinition(viewDefinition) {
    try {
      var _this6 = this;

      return Promise.resolve(callFetch({
        body: viewDefinition,
        headers: {},
        method: 'POST',
        url: _this6.props.dvApiUri + "service/userProfile/validateViewDefinition"
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        return Promise.resolve(response.json());
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Validate the supplied Virtualization name
   * @param virtName the virutalization name
   */


  WithVirtualizationHelpersWrapped.prototype.validateVirtualizationName = function validateVirtualizationName(virtName) {
    try {
      var _this7 = this;

      var encodedName = encodeURIComponent(virtName);
      return Promise.resolve(callFetch({
        headers: {},
        method: 'GET',
        url: _this7.props.dvApiUri + "workspace/dataservices/nameValidation/" + encodedName
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        } // return validation result


        return Promise.resolve(response.text()).then(function (result) {
          var hasError = result.length > 0;
          return {
            error: hasError ? result : '',
            isError: hasError
          };
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Validate the view name for the specified vdb and model
   * @param vdbName the VDB name
   * @param modelName the model name
   * @param viewName the view name
   */


  WithVirtualizationHelpersWrapped.prototype.validateViewName = function validateViewName(vdbName, modelName, viewName) {
    try {
      var _this8 = this;

      var encodedName = encodeURIComponent(viewName);
      return Promise.resolve(callFetch({
        headers: {},
        method: 'GET',
        url: _this8.props.dvApiUri + "workspace/vdbs/" + vdbName + "/Models/" + modelName + "/Views/nameValidation/" + encodedName
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        } // return validation result


        return Promise.resolve(response.text()).then(function (result) {
          var hasError = result.length > 0;
          return {
            error: hasError ? result : '',
            isError: hasError
          };
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Unpublish the Service VDB with the specified name.
   * @param vdbName the name of the vdb associated with the service
   */


  WithVirtualizationHelpersWrapped.prototype.unpublishServiceVdb = function unpublishServiceVdb(vdbName) {
    try {
      var _this9 = this;

      return Promise.resolve(callFetch({
        headers: {},
        method: 'DELETE',
        url: _this9.props.dvApiUri + "metadata/publish/" + vdbName
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        return Promise.resolve();
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Delete the specified ViewEditorState in the komodo user profile
   * @param viewEditorState the view editor state
   */


  WithVirtualizationHelpersWrapped.prototype.deleteViewEditorState = function deleteViewEditorState(viewEditorStateId) {
    try {
      var _this10 = this;

      return Promise.resolve(callFetch({
        headers: {},
        method: 'DELETE',
        url: _this10.props.dvApiUri + "service/userProfile/viewEditorState/" + viewEditorStateId
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        return Promise.resolve();
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Saves ViewEditorStates in the komodo user profile
   * @param viewEditorStates the array of view editor states
   */


  WithVirtualizationHelpersWrapped.prototype.updateViewEditorStates = function updateViewEditorStates(viewEditorStates) {
    try {
      var _this11 = this;

      return Promise.resolve(callFetch({
        body: viewEditorStates,
        headers: {},
        method: 'PUT',
        url: _this11.props.dvApiUri + "service/userProfile/viewEditorStates"
      })).then(function (response) {
        if (!response.ok) {
          throw new Error(response.statusText);
        }

        return Promise.resolve();
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  /**
   * Saves ViewEditorStates in the komodo user profile, then updates the virtualizations
   * @param viewEditorStates the array of view editor states
   */


  WithVirtualizationHelpersWrapped.prototype.refreshVirtualizationViews = function refreshVirtualizationViews(virtualizationName, viewEditorStates) {
    try {
      var _this12 = this; // Updates the view editor states


      return Promise.resolve(_this12.updateViewEditorStates(viewEditorStates)).then(function () {
        return Promise.resolve(callFetch({
          headers: {},
          method: 'POST',
          url: _this12.props.dvApiUri + "workspace/dataservices/refreshViews/" + virtualizationName
        })).then(function (response) {
          if (!response.ok) {
            throw new Error(response.statusText);
          }

          return Promise.resolve();
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  WithVirtualizationHelpersWrapped.prototype.render = function render() {
    return this.props.children({
      createVirtualization: this.createVirtualization,
      deleteView: this.deleteView,
      deleteViewEditorState: this.deleteViewEditorState,
      deleteVirtualization: this.deleteVirtualization,
      publishVirtualization: this.publishVirtualization,
      queryVirtualization: this.queryVirtualization,
      refreshVirtualizationViews: this.refreshVirtualizationViews,
      unpublishServiceVdb: this.unpublishServiceVdb,
      updateViewEditorStates: this.updateViewEditorStates,
      validateViewDefinition: this.validateViewDefinition,
      validateViewName: this.validateViewName,
      validateVirtualizationName: this.validateVirtualizationName
    });
  };

  return WithVirtualizationHelpersWrapped;
}(React.Component);

var WithVirtualizationHelpers = function WithVirtualizationHelpers(props) {
  return React.createElement(ApiContext.Consumer, null, function (apiContext) {
    return React.createElement(WithVirtualizationHelpersWrapped, Object.assign({}, props, apiContext));
  });
};

var WithVirtualizations =
/*@__PURE__*/
function (superclass) {
  function WithVirtualizations() {
    superclass.apply(this, arguments);
  }

  if (superclass) WithVirtualizations.__proto__ = superclass;
  WithVirtualizations.prototype = Object.create(superclass && superclass.prototype);
  WithVirtualizations.prototype.constructor = WithVirtualizations;

  WithVirtualizations.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(DVFetch, {
      url: 'workspace/dataservices',
      defaultValue: []
    }, function (ref) {
      var read = ref.read;
      var response = ref.response;
      return React.createElement(WithPolling, {
        read: read,
        polling: 5000
      }, function () {
        return this$1.props.children(Object.assign({}, response, {
          read: read
        }));
      });
    });
  };

  return WithVirtualizations;
}(React.Component);

function useApiConnectorCreator() {
  var apiContext = React.useContext(ApiContext);

  var createConnector = function createConnector(connector) {
    try {
      var body = new FormData();
      body.append('connectorSettings', new Blob([JSON.stringify({
        configuredProperties: {
          authenticationType: connector.authenticationType,
          authorizationEndpoint: connector.authorizationEndpoint,
          basePath: connector.basePath,
          host: connector.host,
          specification: connector.specification,
          tokenEndpoint: connector.tokenEndpoint
        },
        connectorTemplateId: 'swagger-connector-template',
        description: connector.description,
        icon: connector.icon,
        name: connector.name
      })], {
        type: 'application/json'
      }));
      return Promise.resolve(callFetch({
        body: body,
        headers: apiContext.headers,
        includeAccept: true,
        includeContentType: false,
        method: 'POST',
        url: apiContext.apiUri + "/connectors/custom"
      })).then(function (response) {
        return Promise.resolve(response.json()).then(function (integration) {
          if (integration.errorCode) {
            throw new Error(integration.userMsg);
          }

          return integration;
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return createConnector;
}

function useApiProviderSpecification(specificationOrIntegration) {
  var apiContext = React.useContext(ApiContext);
  var ref = React.useState(false);
  var loading = ref[0];
  var setLoading = ref[1];
  var ref$1 = React.useState(false);
  var error = ref$1[0];
  var setError = ref$1[1];
  var ref$2 = React.useState(undefined);
  var specification = ref$2[0];
  var setSpecification = ref$2[1];
  React.useEffect(function () {
    var fetchSpecification = function fetchSpecification() {
      try {
        setLoading(true);
        return Promise.resolve(_finallyRethrows(function () {
          return _catch(function () {
            return Promise.resolve(callFetch({
              headers: apiContext.headers,
              method: 'GET',
              url: apiContext.apiUri + "/integrations/" + specificationOrIntegration.id + "/specification"
            })).then(function (response) {
              return Promise.resolve(response.json()).then(function (integrationSpecification) {
                if (integrationSpecification.errorCode) {
                  throw new Error(integrationSpecification.userMsg);
                }

                setSpecification(JSON.stringify(integrationSpecification));
              });
            });
          }, function (e) {
            setError(e);
          });
        }, function (_wasThrown, _result) {
          setLoading(false);

          if (_wasThrown) {
            throw _result;
          }

          return _result;
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    };

    if (typeof specificationOrIntegration === 'string') {
      setSpecification(specificationOrIntegration);
    } else {
      fetchSpecification();
    }
  }, [specificationOrIntegration, apiContext, setLoading]);
  return {
    specification: specification,
    loading: loading,
    error: error
  };
}

function useApiProviderIntegration() {
  var apiContext = React.useContext(ApiContext);

  var getIntegration = function getIntegration(specification) {
    try {
      var body = new FormData();
      body.append('specification', specification);
      return Promise.resolve(callFetch({
        body: body,
        headers: apiContext.headers,
        includeAccept: true,
        includeContentType: false,
        method: 'POST',
        url: apiContext.apiUri + "/apis/generator"
      })).then(function (response) {
        return Promise.resolve(response.json()).then(function (integration) {
          if (integration.errorCode) {
            throw new Error(integration.userMsg);
          }

          return integration;
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return getIntegration;
}

exports.useApiConnectorCreator = useApiConnectorCreator;
exports.useApiProviderSpecification = useApiProviderSpecification;
exports.useApiProviderIntegration = useApiProviderIntegration;
exports.useConnectorCredentialsConnect = useConnectorCredentialsConnect;
exports.ApiContextDefaultValue = ApiContextDefaultValue;
exports.ApiContext = ApiContext;
exports.callFetch = callFetch;
exports.NEW_INTEGRATION_ID = NEW_INTEGRATION_ID;
exports.NEW_INTEGRATION = NEW_INTEGRATION;
exports.PENDING = PENDING;
exports.PUBLISHED = PUBLISHED;
exports.UNPUBLISHED = UNPUBLISHED;
exports.ERROR = ERROR;
exports.FLOW_KIND_METADATA_KEY = FLOW_KIND_METADATA_KEY;
exports.EXCERPT_METADATA_KEY = EXCERPT_METADATA_KEY;
exports.STEP_ID_METADATA_KEY = STEP_ID_METADATA_KEY;
exports.PRIMARY_FLOW_ID_METADATA_KEY = PRIMARY_FLOW_ID_METADATA_KEY;
exports.HIDE_FROM_STEP_SELECT = HIDE_FROM_STEP_SELECT;
exports.HIDE_FROM_CONNECTION_PAGES = HIDE_FROM_CONNECTION_PAGES;
exports.EXTENSION = EXTENSION;
exports.ENDPOINT = ENDPOINT;
exports.FLOW = FLOW;
exports.CONNECTION = CONNECTION;
exports.DATA_MAPPER = DATA_MAPPER;
exports.BASIC_FILTER = BASIC_FILTER;
exports.ADVANCED_FILTER = ADVANCED_FILTER;
exports.SPLIT = SPLIT;
exports.AGGREGATE = AGGREGATE;
exports.LOG = LOG;
exports.TEMPLATE = TEMPLATE;
exports.API_PROVIDER = API_PROVIDER;
exports.CONNECTOR = CONNECTOR;
exports.CHOICE = CHOICE;
exports.DVFetch = DVFetch;
exports.Fetch = Fetch;
exports.getActionsWithFrom = getActionsWithFrom;
exports.getActionsWithTo = getActionsWithTo;
exports.getConnectionMetadataValue = getConnectionMetadataValue;
exports.getConnectionConnector = getConnectionConnector;
exports.getConnectorActions = getConnectorActions;
exports.getActionById = getActionById;
exports.getActionDescriptor = getActionDescriptor;
exports.getActionSteps = getActionSteps;
exports.getActionStep = getActionStep;
exports.getActionStepDefinition = getActionStepDefinition;
exports.isDerived = isDerived;
exports.setFlow = setFlow;
exports.sanitizeFlow = sanitizeFlow;
exports.toDataShapeKindType = toDataShapeKindType;
exports.toDataShapeKinds = toDataShapeKinds;
exports.getEmptyIntegration = getEmptyIntegration;
exports.setIntegrationProperties = setIntegrationProperties;
exports.canPublish = canPublish;
exports.canActivate = canActivate;
exports.canEdit = canEdit;
exports.canDeactivate = canDeactivate;
exports.getSteps = getSteps;
exports.isUserDefinedDataShape = isUserDefinedDataShape;
exports.hasDataShape = hasDataShape;
exports.isActionShapeless = isActionShapeless;
exports.isActionInputShapeless = isActionInputShapeless;
exports.requiresOutputDescribeDataShape = requiresOutputDescribeDataShape;
exports.requiresInputDescribeDataShape = requiresInputDescribeDataShape;
exports.isActionOutputShapeless = isActionOutputShapeless;
exports.setIntegrationProperty = setIntegrationProperty;
exports.createStep = createStep;
exports.createConnectionStep = createConnectionStep;
exports.createStepWithConnection = createStepWithConnection;
exports.addMetadataToStep = addMetadataToStep;
exports.setDataShapeOnStep = setDataShapeOnStep;
exports.setConfiguredPropertiesOnStep = setConfiguredPropertiesOnStep;
exports.setActionOnStep = setActionOnStep;
exports.setDescriptorOnStep = setDescriptorOnStep;
exports.applyUserDefinedDataShapesToAction = applyUserDefinedDataShapesToAction;
exports.setDescriptorOnAction = setDescriptorOnAction;
exports.stringifyValues = stringifyValues;
exports.prepareIntegrationForSaving = prepareIntegrationForSaving;
exports.getFlow = getFlow;
exports.reconcileConditionalFlows = reconcileConditionalFlows;
exports.getFlowsWithoutLinkedStepId = getFlowsWithoutLinkedStepId;
exports.insertStepIntoFlowAfter = insertStepIntoFlowAfter;
exports.insertStepIntoFlowBefore = insertStepIntoFlowBefore;
exports.setStepInFlow = setStepInFlow;
exports.applyUpdatedStep = applyUpdatedStep;
exports.removeStepFromFlow = removeStepFromFlow;
exports.insertStepAfter = insertStepAfter;
exports.insertStepBefore = insertStepBefore;
exports.createFlowWithId = createFlowWithId;
exports.createConditionalFlow = createConditionalFlow;
exports.getFirstPosition = getFirstPosition;
exports.getLastPosition = getLastPosition;
exports.getStepsLastPosition = getStepsLastPosition;
exports.getMiddlePosition = getMiddlePosition;
exports.getStep = getStep;
exports.getStartStep = getStartStep;
exports.getLastStep = getLastStep;
exports.getMiddleSteps = getMiddleSteps;
exports.getIntegrationSubsequentSteps = getIntegrationSubsequentSteps;
exports.getSubsequentSteps = getSubsequentSteps;
exports.getPreviousIntegrationSteps = getPreviousIntegrationSteps;
exports.getPreviousSteps = getPreviousSteps;
exports.getSubsequentConnections = getSubsequentConnections;
exports.getPreviousConnections = getPreviousConnections;
exports.getPreviousConnection = getPreviousConnection;
exports.getSubsequentConnection = getSubsequentConnection;
exports.getSubsequentIntegrationStepsWithDataShape = getSubsequentIntegrationStepsWithDataShape;
exports.getPreviousIntegrationStepsWithDataShape = getPreviousIntegrationStepsWithDataShape;
exports.getPreviousStepsWithDataShape = getPreviousStepsWithDataShape;
exports.getPreviousIntegrationStepIndexWithDataShape = getPreviousIntegrationStepIndexWithDataShape;
exports.getPreviousIntegrationStepWithDataShape = getPreviousIntegrationStepWithDataShape;
exports.getPreviousStepWithDataShape = getPreviousStepWithDataShape;
exports.getSubsequentIntegrationStepWithDataShape = getSubsequentIntegrationStepWithDataShape;
exports.validateFlow = validateFlow;
exports.getIntegrationNextAggregateStep = getIntegrationNextAggregateStep;
exports.getNextAggregateStep = getNextAggregateStep;
exports.isStartStep = isStartStep;
exports.isEndStep = isEndStep;
exports.atEnd = atEnd;
exports.isMiddleStep = isMiddleStep;
exports.createConditionalFlowStart = createConditionalFlowStart;
exports.createConditionalFlowEnd = createConditionalFlowEnd;
exports.getMetadataValue = getMetadataValue;
exports.isIntegrationApiProvider = isIntegrationApiProvider;
exports.isPrimaryFlow = isPrimaryFlow;
exports.isAlternateFlow = isAlternateFlow;
exports.isConditionalFlow = isConditionalFlow;
exports.isDefaultFlow = isDefaultFlow;
exports.isApiProviderFlow = isApiProviderFlow;
exports.getApiProviderFlows = getApiProviderFlows;
exports.getConditionalFlows = getConditionalFlows;
exports.getDefaultFlow = getDefaultFlow;
exports.getConditionalFlowGroups = getConditionalFlowGroups;
exports.getConditionalFlowGroupsFor = getConditionalFlowGroupsFor;
exports.getPrimaryFlowId = getPrimaryFlowId;
exports.serializeIntegration = serializeIntegration;
exports.deserializeIntegration = deserializeIntegration;
exports.ServerEventsContextDefaultValue = ServerEventsContextDefaultValue;
exports.ServerEventsContext = ServerEventsContext;
exports.Stream = Stream;
exports.SyndesisFetch = SyndesisFetch;
exports.useApiConnectorSummary = useApiConnectorSummary;
exports.useApiProviderSummary = useApiProviderSummary;
exports.useConnectionHelpers = useConnectionHelpers;
exports.transformConnectionResponse = transformConnectionResponse;
exports.useConnection = useConnection;
exports.useConnector = useConnector;
exports.useConnectorVerifier = useConnectorVerifier;
exports.useConnectorCredentials = useConnectorCredentials;
exports.useIntegrationHelpers = useIntegrationHelpers;
exports.WithActionDescriptor = WithActionDescriptor;
exports.WithActivities = WithActivities;
exports.WithApiConnector = WithApiConnector;
exports.WithApiConnectorHelpersWrapped = WithApiConnectorHelpersWrapped;
exports.WithApiConnectorHelpers = WithApiConnectorHelpers;
exports.WithApiConnectors = WithApiConnectors;
exports.WithApiVersion = WithApiVersion;
exports.WithChangeListener = WithChangeListener;
exports.WithConnection = WithConnection;
exports.WithConnectionHelpers = WithConnectionHelpers;
exports.getConnectionsForDisplay = getConnectionsForDisplay;
exports.getConnectionsWithFromAction = getConnectionsWithFromAction;
exports.getConnectionsWithToAction = getConnectionsWithToAction;
exports.transformResponse = transformResponse;
exports.WithConnections = WithConnections;
exports.WithConnector = WithConnector;
exports.getConnectorsForDisplay = getConnectorsForDisplay;
exports.transformConnectorsResponse = transformConnectorsResponse;
exports.WithConnectors = WithConnectors;
exports.WithEnvironmentHelpersWrapped = WithEnvironmentHelpersWrapped;
exports.WithEnvironmentHelpers = WithEnvironmentHelpers;
exports.WithEnvironments = WithEnvironments;
exports.WithExtension = WithExtension;
exports.WithExtensionHelpersWrapped = WithExtensionHelpersWrapped;
exports.WithExtensionHelpers = WithExtensionHelpers;
exports.WithExtensionIntegrations = WithExtensionIntegrations;
exports.WithExtensions = WithExtensions;
exports.WithFilterOptions = WithFilterOptions;
exports.WithIntegration = WithIntegration;
exports.WithIntegrationHelpers = WithIntegrationHelpers;
exports.WithIntegrationMetrics = WithIntegrationMetrics;
exports.WithIntegrations = WithIntegrations;
exports.WithIntegrationsMetrics = WithIntegrationsMetrics;
exports.WithIntegrationTags = WithIntegrationTags;
exports.WithMonitoredIntegration = WithMonitoredIntegration;
exports.WithMonitoredIntegrations = WithMonitoredIntegrations;
exports.WithOAuthAppHelpersWrapped = WithOAuthAppHelpersWrapped;
exports.WithOAuthAppHelpers = WithOAuthAppHelpers;
exports.WithOAuthApps = WithOAuthApps;
exports.WithPolling = WithPolling;
exports.EVENT_SERVICE_CONNECTED = EVENT_SERVICE_CONNECTED;
exports.WithServerEvents = WithServerEvents;
exports.ALL_STEPS = ALL_STEPS;
exports.WithSteps = WithSteps;
exports.WithUser = WithUser;
exports.WithUserHelpersWrapped = WithUserHelpersWrapped;
exports.WithUserHelpers = WithUserHelpers;
exports.WithVdbModel = WithVdbModel;
exports.WithViewEditorStates = WithViewEditorStates;
exports.WithViews = WithViews;
exports.WithVirtualization = WithVirtualization;
exports.WithVirtualizationConnectionSchema = WithVirtualizationConnectionSchema;
exports.WithVirtualizationConnectionStatuses = WithVirtualizationConnectionStatuses;
exports.WithVirtualizationHelpersWrapped = WithVirtualizationHelpersWrapped;
exports.WithVirtualizationHelpers = WithVirtualizationHelpers;
exports.WithVirtualizations = WithVirtualizations;